<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 text-center mt-2 mb-2">
          <h4><b>ค้นหาขอบเขตการวิ่งของมินิ ณ ปัจจุบัน <i class="far fa-map-marked-alt"></i></b></h4>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-xs-6 col-sm-12">
            <div class="form-group row text-center">
              <label class="col-sm-5 col-form-label"><b><i class="far fa-globe"></i> ภูมิภาค/จังหวัด:&nbsp;</b></label>
              <div class="col-sm-7">
                <treeselect :multiple="true" :limit='1' :options="options.region" placeholder="เลือกภูมิภาค/จังหวัด..." v-model="data.region" @input="onChangeRegion()" valueFormat="object" :disabled="load.active"/>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-6 col-sm-12">
            <div class="form-group row text-center">
              <label class="col-sm-5 col-form-label"><b><i class="far fa-map-signs"></i> เขต/อำเภอ:&nbsp;</b></label>
              <div class="col-sm-7">
                <treeselect :multiple="true" :limit='1' :options="options.province" :placeholder="placeholder.province" v-model="data.province" valueFormat="object" :disabled="options.province.length<=0||load.active" @input="onChangeProvince()"/>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-6 col-sm-12">
            <div class="form-group row text-center">
              <label class="col-sm-5 col-form-label"><b><i class="far fa-map-pin"></i> แขวง/ตำบล:&nbsp;</b></label>
              <div class="col-sm-7">
                <treeselect :multiple="true" :limit='1' :options="options.district" :placeholder="placeholder.district" v-model="data.district" valueFormat="object" :disabled="options.district.length<=0||load.active"  @input="onChangeDistrict()"/>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-6 col-sm-12">
            <div class="form-group row text-center">
              <label class="col-sm-5 col-form-label"><b><i class="far fa-warehouse-alt"></i> ศูนย์จัดจำหน่าย:&nbsp;</b></label>
              <div class="col-sm-7">
                <treeselect :multiple="true" :limit='1' :options="options.dts" :placeholder="(options.dts.length > 0 ? 'เลือกศูนย์จัดจำหน่าย':'ไม่มีข้อมูลศูนย์จัดจำหน่ายที่เชื่อมGPS')" v-model="data.dts" valueFormat="object" :disabled="options.dts.length<=0||load.active" @input="onChangeDTs()"/>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xs-6 col-sm-12">
              <div class="form-group row text-center">
                <label class="col-sm-5 col-form-label"><b><i class="far fa-store-alt"></i> มินิ:&nbsp;</b></label>
                <div class="col-sm-7">
                  <treeselect :multiple="true" :limit='1' :options="options.minis" :placeholder="(options.minis.length > 0 ? 'เลือกมินิ':'ไม่มีข้อมูลมินิที่เชื่อมGPS')" v-model="data.minis" valueFormat="object" :disabled="options.minis.length<=0||load.active" @input="onChangeMinis()"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xs-6 col-sm-12">
                <div class="form-group row text-center">
                  <label class="col-sm-5 col-form-label"><b><i class="far fa-users"></i> วอลล์แมน/เลดี้:&nbsp;</b></label>
                  <div class="col-sm-7">
                    <treeselect :multiple="true" :limit='1' :options="options.wms" :placeholder="(options.wms.length > 0 ? 'เลือกวอลล์แมน/เลดี้':'ไม่มีข้อมูลวอลล์แมน/เลดี้ที่เชื่อมGPS')" v-model="data.wms" valueFormat="object" :disabled="options.wms.length<=0||load.active" @input="onChangeWMs()"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-xs-6 col-sm-12">
                  <div class="form-group row text-center">
                    <label class="col-sm-5 col-form-label"><b><i class="fas fa-map-marker-alt"></i> เพิ่มจุดสนใจ:&nbsp;</b></label>
                    <div class="col-sm-7">
                      <treeselect :multiple="true" :limit='1' :options="options.poi" placeholder="เลือกเพิ่มจดสนใจ" v-model="data.poi" valueFormat="object" :disabled="load.active" @input="onChangePOI()">
                        <div slot="option-label" slot-scope="{ node }">
                          <label style="color:#54a910;" v-if="node.raw.id==='attraction'"> {{ node.raw.label }} <i class="fas fa-archway" aria-hidden="true"></i></label>
                          <label style="color:#7289d9;" v-else-if="node.raw.id==='business'"> {{ node.raw.label }} <i class="fas fa-store" aria-hidden="true"></i></label>
                          <label style="color:#f6412d;" v-else-if="node.raw.id==='medical'"> {{ node.raw.label }} <i class="fas fa-hospital" aria-hidden="true"></i></label>
                          <label style="color:#FFC100;" v-else-if="node.raw.id==='place_of_worship'"> {{ node.raw.label }} <i class="fas fa-church" aria-hidden="true"></i></label>
                          <label style="color:#AF974D;" v-else-if="node.raw.id==='government'"> {{ node.raw.label }} <i class="fas fa-university" aria-hidden="true"></i></label>
                          <label style="color:#B391DB;" v-else-if="node.raw.id==='school'"> {{ node.raw.label }} <i class="fas fa-school" aria-hidden="true"></i></label>
                        </div>
                      </treeselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <hr>
              <div class="row">
                <div class="col-md-12 col-xs-12 col-sm-12 text-center">
                  <button type="button" class="btn btn-primary form-control" v-if="options.filter.active===false" @click="options.filter.active=true"><b><i class="far fa-eye"></i> ค้นหาประวัติย้อนหลังเส้นทางการวิ่ง</b></button>
                  <button type="button" class="btn btn-secondary form-control" v-else @click="options.filter.active=false"><b><i class="far fa-eye-slash"></i> ซ่อนการค้นหา</b></button>
                </div>
              </div>
              <div class="card card-option" v-if="options.filter.active===true">
                <div class="container mb-2">
                  <div class="row">
                    <div class="card card-option">
                      <div class="container mt-2">
                        <div class="row">
                          <div class="col-md-7 col-xs-7 col-sm-12">
                            <div class="form-group row text-center">
                              <label class="col-sm-4 col-form-label"><b><i class="far fa-warehouse-alt"></i> ศูนย์จัดจำหน่าย:&nbsp;</b></label>
                              <div class="col-sm-8">
                                <treeselect :multiple="true" :limit='1' :options="options.filter.dts" :placeholder="(options.filter.dts.length > 0 ? 'เลือกศูนย์จัดจำหน่าย':'ไม่มีข้อมูลศูนย์จัดจำหน่ายที่เชื่อมGPS')" v-model="data.filter.dts" valueFormat="object" :disabled="options.dts.length<=0||load.active"/>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5 col-xs-5 col-sm-12">
                              <div class="form-group row text-center">
                                <label class="col-sm-6 col-form-label"><b><i class="far fa-filter"></i> ตัวกรองศูนย์จัดจำหน่าย:&nbsp;</b></label>
                                <div class="col-sm-6">
                                  <treeselect :multiple="true" :limit='1' :options="options.filter.options" :placeholder="(options.filter.dts.length > 0 ? 'ตัวกรองศูนย์จัดจำหน่าย':'ไม่มีข้อมูลศูนย์จัดจำหน่ายที่เชื่อมGPS')" v-model="data.filter.options.dts" :disabled="options.dts.length<=0||load.active"/>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-7 col-xs-7 col-sm-12">
                                <div class="form-group row text-center">
                                  <label class="col-sm-4 col-form-label"><b><i class="far fa-store-alt"></i> มินิ:&nbsp;</b></label>
                                  <div class="col-sm-8">
                                    <treeselect :multiple="true" :limit='1' :options="options.filter.minis" :placeholder="(options.filter.minis.length > 0 ? 'เลือกมินิ':'ไม่มีข้อมูลมินิที่เชื่อมGPS')" v-model="data.filter.minis" valueFormat="object" :disabled="options.minis.length<=0||load.active"/>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-5 col-xs-5 col-sm-12">
                                  <div class="form-group row text-center">
                                    <label class="col-sm-6 col-form-label"><b><i class="far fa-filter"></i> ตัวกรองมินิ:&nbsp;</b></label>
                                    <div class="col-sm-6">
                                      <treeselect :multiple="true" :limit='1' :options="options.filter.options" :placeholder="(options.filter.minis.length > 0 ? 'ตัวกรองมินิ':'ไม่มีข้อมูลมินิที่เชื่อมGPS')" v-model="data.filter.options.minis" :disabled="options.minis.length<=0||load.active"/>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-7 col-xs-7 col-sm-12">
                                    <div class="form-group row text-center">
                                      <label class="col-sm-4 col-form-label"><b><i class="far fa-users"></i> วอลล์แมน/เลดี้:&nbsp;</b></label>
                                      <div class="col-sm-8">
                                        <treeselect :multiple="true" :limit='1' :options="options.filter.wms" :placeholder="(options.filter.wms.length > 0 ? 'เลือกวอลล์แมน/เลดี้':'ไม่มีข้อมูลวอลล์แมน/เลดี้ที่เชื่อมGPS')" v-model="data.filter.wms" valueFormat="object" :disabled="options.filter.wms.length<=0||load.active"/>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-5 col-xs-5 col-sm-12">
                                      <div class="form-group row text-center">
                                        <label class="col-sm-6 col-form-label"><b><i class="far fa-filter"></i> ตัวกรองวอลล์แมน/เลดี้:&nbsp;</b></label>
                                        <div class="col-sm-6">
                                          <treeselect :multiple="true" :limit='1' :options="options.filter.options" :placeholder="(options.filter.wms.length > 0 ? 'ตัวกรองวอลล์แมน/เลดี้':'ไม่มีข้อมูลวอลล์แมน/เลดี้ที่เชื่อมGPS')" v-model="data.filter.options.wms" :disabled="options.filter.wms.length<=0||load.active"/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-xs-6 col-sm-12">
                                  <div class="form-group row text-center">
                                    <label class="col-sm-5 col-form-label"><b><i class="far fa-calendar-alt"></i> ช่วงวันที่:&nbsp;</b></label>
                                    <div class="col-sm-7">
                                      <v-date-picker mode='range' v-model='picker' :input-props='{ class:"pull-right text-center form-control",style:"background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%", placeholder: "กรุณาเลือกช่วงวันที่ต้องการทราบ", readonly: true }'
                                      show-caps></v-date-picker>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-xs-6 col-sm-12">
                                  <div class="form-group row text-center">
                                    <label class="col-sm-5 col-form-label"><b><i class="far fa-wave-triangle"></i> ช่วงเวลาความถี่:&nbsp;</b></label>
                                    <div class="col-sm-7">
                                      <treeselect :options="options.frequency" placeholder="เลือกช่วงเวลาความถี่" v-model="data.frequency" :disabled="load.active"/>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-xs-6 col-sm-6">
                                  <div class="form-group row text-center">
                                    <label class="col-sm-5 col-form-label"><b><i class="far fa-clock"></i> ช่วงเวลาเริ่มต้น:&nbsp;</b></label>
                                    <div class="col-sm-7">
                                      <treeselect :options="options.time.start" placeholder="เลือกช่วงเวลาเริ่มต้น" v-model="data.time.start" :disabled="load.active" @input="onChangeTimeStart()"/>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6 col-xs-6 col-sm-6">
                                  <div class="form-group row text-center">
                                    <label class="col-sm-5 col-form-label"><b><i class="far fa-clock"></i> ช่วงเวลาสิ้นสุด:&nbsp;</b></label>
                                    <div class="col-sm-7">
                                      <treeselect :options="options.time.end" :placeholder="(options.time.end.length > 0 ? 'เลือกช่วงเวลาสิ้นสุด':'กรุณาเลือกช่วงเวลาเริ่มต้น')" v-model="data.time.end" :disabled="options.time.end.length<=0||load.active"/>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-xs-12 col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12 col-xs-12 col-sm-12">
                                        <div class="container">
                                          <div class="row">
                                            <div class="offset-md-1 offset-xs-1 offset-sm-1 col-md-5 col-xs-5 col-sm-5 mt-2">
                                              <button type="button" class="btn btn-primary form-control" @click="onChangeSearch"><b><i class="far fa-search"></i> ค้นหาประวัติเส้นทาง</b></button>
                                            </div>
                                            <div class="col-md-5 col-xs-5 col-sm-5 mt-2">
                                              <button type="button" class="btn btn-light form-control" @click="clearSearch"><b><i class="far fa-eraser"></i> ล้างประวัติการค้นหา</b></button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="container">
                            <div class="row">
                              <div class="col-md-12 col-xs-12 col-sm-12 text-center mb-1">
                                <div ref="map" style="width: 100%;height: 552px;"></div>
                              </div>
                            </div>
                          </div>
                          <div class="container mb-4">
                            <div class="row">
                              <div class="col-md-12 col-xs-12 col-sm-12 text-center mb-1">
                                <vue-bootstrap4-table :rows="table.rows" :columns="table.columns" :config="table.config">
                                  <template slot="dt" slot-scope="props">
                                    <span class="badge" v-bind:style="{ backgroundColor: props.cell_value}">&nbsp;&nbsp;&nbsp;</span>
                                  </template>
                                  <template slot="mini" slot-scope="props">
                                    <span class="badge" v-bind:style="{ backgroundColor: props.cell_value}">&nbsp;&nbsp;&nbsp;</span>
                                  </template>
                                  <template slot="wm" slot-scope="props">
                                    <span class="badge" v-bind:style="{ backgroundColor: props.cell_value}">&nbsp;&nbsp;&nbsp;</span>
                                  </template>
                                </vue-bootstrap4-table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Loading :percent="load.percent" :active="load.active" :text="load.text"></Loading>
                      </div>
                    </template>
                    <script>
                    import Vue from 'vue';
                    import VCalendar from 'v-calendar';
                    import 'v-calendar/lib/v-calendar.min.css';
                    import Number from '../../utils/Number.js';
                    import JWT from '../../utils/JWT.js';
                    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
                    Vue.use(VCalendar);
                    export default {
                      components: {
                        'VueBootstrap4Table': () => import('vue-bootstrap4-table'),
                        'treeselect': () => import('@riophae/vue-treeselect'),
                        'Loading': () => import('../../utils/Loading.vue')
                      },
                      data() {
                        return {
                          picker: {
                            start: this.$moment().toDate(),
                            end: this.$moment().toDate()
                          },
                          colors:['#F44336','#FFCDD2','#EF9A9A','#E57373','#EF5350','#F44336','#E53935','#D32F2F','#C62828','#B71C1C','#FF8A80','#FF5252','#FF1744','#D50000','#E91E63','#F8BBD0','#F48FB1','#F06292','#EC407A','#E91E63','#D81B60','#C2185B','#AD1457','#880E4F','#FF80AB','#FF4081','#F50057','#C51162','#9C27B0','#E1BEE7','#CE93D8','#BA68C8','#AB47BC','#9C27B0','#8E24AA','#7B1FA2','#6A1B9A','#4A148C','#EA80FC','#E040FB','#D500F9','#AA00FF','#673AB7','#D1C4E9','#B39DDB','#9575CD','#7E57C2','#673AB7','#5E35B1','#512DA8','#4527A0','#311B92','#B388FF','#7C4DFF','#651FFF','#6200EA','#3F51B5','#C5CAE9','#9FA8DA','#7986CB','#5C6BC0','#3F51B5','#3949AB','#303F9F','#283593','#1A237E','#8C9EFF','#536DFE','#3D5AFE','#304FFE','#2196F3','#BBDEFB','#90CAF9','#64B5F6','#42A5F5','#2196F3','#1E88E5','#1976D2','#1565C0','#0D47A1','#82B1FF','#448AFF','#2979FF','#2962FF','#03A9F4','#B3E5FC','#81D4FA','#4FC3F7','#29B6F6','#03A9F4','#039BE5','#0288D1','#0277BD','#01579B','#80D8FF','#40C4FF','#00B0FF','#0091EA','#00BCD4','#B2EBF2','#80DEEA','#4DD0E1','#26C6DA','#00BCD4','#00ACC1','#0097A7','#00838F','#006064','#84FFFF','#18FFFF','#00E5FF','#00B8D4','#009688','#B2DFDB','#80CBC4','#4DB6AC','#26A69A','#009688','#00897B','#00796B','#00695C','#004D40','#A7FFEB','#64FFDA','#1DE9B6','#00BFA5','#4CAF50','#C8E6C9','#A5D6A7','#81C784','#66BB6A','#4CAF50','#43A047','#388E3C','#2E7D32','#1B5E20','#B9F6CA','#69F0AE','#00E676','#00C853','#8BC34A','#DCEDC8','#C5E1A5','#AED581','#9CCC65','#8BC34A','#7CB342','#689F38','#558B2F','#33691E','#CCFF90','#B2FF59','#76FF03','#64DD17','#CDDC39','#F0F4C3','#E6EE9C','#DCE775','#D4E157','#CDDC39','#C0CA33','#AFB42B','#9E9D24','#827717','#F4FF81','#EEFF41','#C6FF00','#AEEA00','#FFEB3B','#FFF9C4','#FFF59D','#FFF176','#FFEE58','#FFEB3B','#FDD835','#FBC02D','#F9A825','#F57F17','#FFFF8D','#FFFF00','#FFEA00','#FFD600','#FFC107','#FFECB3','#FFE082','#FFD54F','#FFCA28','#FFC107','#FFB300','#FFA000','#FF8F00','#FF6F00','#FFE57F','#FFD740','#FFC400','#FFAB00','#FF9800','#FFE0B2','#FFCC80','#FFB74D','#FFA726','#FF9800','#FB8C00','#F57C00','#EF6C00','#E65100','#FFD180','#FFAB40','#FF9100','#FF6D00','#FF5722','#FFCCBC','#FFAB91','#FF8A65','#FF7043','#FF5722','#F4511E','#E64A19','#D84315','#BF360C','#FF9E80','#FF6E40','#FF3D00','#DD2C00','#795548','#D7CCC8','#BCAAA4','#A1887F','#8D6E63','#795548','#6D4C41','#5D4037','#4E342E','#3E2723','#9E9E9E'],
                          svg:{
                            mini:{
                              start:'M24.688 0.662c-0.256 0.15-0.8 0.463-1.206 0.694-0.413 0.231-1.056 0.613-1.438 0.838-0.387 0.225-0.825 0.475-0.981 0.556s-0.556 0.306-0.887 0.506c-0.337 0.206-0.8 0.475-1.031 0.6-0.544 0.306-1.206 0.681-2.163 1.25-0.419 0.25-0.825 0.456-0.9 0.456s-0.463-0.188-0.856-0.425c-0.394-0.231-1.088-0.631-1.537-0.888s-1.137-0.656-1.525-0.881c-0.381-0.231-0.85-0.5-1.037-0.6s-0.594-0.331-0.906-0.513c-1.306-0.769-2.094-1.219-2.531-1.456-0.256-0.137-0.494-0.281-0.525-0.306-0.131-0.119-0.162-0.037-0.162 0.4v0.463l3.075 1.769c1.694 0.975 3.706 2.131 4.463 2.575 0.762 0.438 1.438 0.8 1.513 0.8 0.069 0 0.725-0.344 1.462-0.769 3.031-1.756 6.863-3.956 7.269-4.188 0.244-0.137 0.45-0.256 0.462-0.269 0.050-0.044 0.019-0.863-0.031-0.875-0.031-0.006-0.269 0.113-0.525 0.262z M4.438 11.581v10.206l0.331 0.194c0.175 0.106 0.787 0.462 1.356 0.788 1.219 0.7 3.669 2.106 5.844 3.356 0.863 0.494 2.044 1.175 2.625 1.506 0.588 0.337 1.144 0.669 1.238 0.744 0.175 0.137 0.175 0.137 0.313 0.019 0.075-0.069 0.262-0.194 0.419-0.281 0.256-0.137 2.981-1.7 4.938-2.831 1.413-0.819 5.081-2.925 5.581-3.2l0.481-0.275v-20.431h-1.219c-0.669 0-1.219 0.025-1.219 0.050 0 0.081-1.938 1.262-2.675 1.631-0.15 0.075-0.419 0.231-0.594 0.344-0.181 0.112-0.538 0.319-0.794 0.462-0.256 0.137-0.769 0.431-1.137 0.644-0.375 0.219-1.044 0.612-1.494 0.869-0.444 0.256-1.137 0.656-1.531 0.888-0.394 0.237-0.769 0.425-0.831 0.425s-0.481-0.219-0.931-0.487c-0.45-0.263-1.037-0.606-1.306-0.763-0.744-0.431-1.85-1.063-2.581-1.481-0.363-0.206-0.894-0.513-1.188-0.688s-0.969-0.563-1.5-0.862c-0.531-0.3-1.144-0.656-1.356-0.788l-0.394-0.244h-2.375v10.206zM14.387 7.731l0.55 0.55v0.906h-1.063v-0.231c0-0.175-0.050-0.281-0.2-0.438l-0.2-0.206h-3.063l-0.412 0.4v5.375l0.463 0.475h2.95l0.231-0.238 0.238-0.238-0.019-1.063-0.019-1.056-1.044-0.019-1.050-0.012v-1.063h3.188v3.719l-1.031 1.031h-3.938l-0.519-0.556-0.512-0.563v-6.225l1.094-1.094h3.813l0.544 0.544zM22.262 7.731l0.55 0.55v6.313l-1.031 1.031h-4.25l-1.094-1.094v-6.256l0.556-0.544 0.55-0.544h4.175l0.544 0.544zM13.813 17.625c0 0.031 0.119 0.087 0.269 0.125 0.544 0.137 1.025 0.331 1.5 0.6l0.481 0.275 0.488-0.275c1.806-1.044 3.431-0.731 4.225 0.8 0.194 0.375 0.225 0.488 0.225 0.875 0 0.4-0.031 0.506-0.25 0.956-0.281 0.563-0.631 0.994-1.031 1.269-0.281 0.194-1.087 0.625-1.169 0.625-0.119 0-0.025-0.119 0.256-0.325 0.169-0.125 0.431-0.394 0.587-0.594 0.875-1.144 0.969-2.231 0.244-2.906-0.381-0.356-0.663-0.45-1.325-0.45-0.631 0-1.044 0.087-1.738 0.381l-0.512 0.219-0.55-0.219c-1.281-0.519-2.412-0.55-3.031-0.081-1.106 0.831-0.45 2.581 1.294 3.406 0.481 0.231 1.219 0.425 1.806 0.481 0.531 0.044 0.687-0.012 1.35-0.512 0.512-0.387 0.856-0.825 0.981-1.256 0.313-1.063-0.688-1.462-1.619-0.65l-0.206 0.181-0.275-0.188c-0.406-0.275-0.787-0.425-1.069-0.425-0.319 0-0.456 0.075-0.55 0.3-0.169 0.4 0.2 1.094 0.806 1.519 0.206 0.15 0.35 0.281 0.319 0.294-0.113 0.038-1.262-0.538-1.619-0.806-0.894-0.675-0.925-1.45-0.069-1.887 0.281-0.144 0.425-0.175 0.787-0.175 0.575 0 0.869 0.087 1.275 0.4 0.213 0.156 0.356 0.225 0.4 0.194 0.775-0.6 1.375-0.731 2-0.438 0.606 0.281 0.906 0.712 0.906 1.3-0.006 0.95-0.906 1.794-2.663 2.5-0.281 0.119-0.425 0.137-0.619 0.106-0.137-0.025-0.537-0.094-0.894-0.15-0.781-0.125-1.569-0.387-2.131-0.694-0.531-0.3-1.25-1.019-1.45-1.45-0.081-0.175-0.169-0.325-0.194-0.325-0.031 0-0.050-0.306-0.050-0.681 0-0.619 0.012-0.706 0.169-0.981 0.269-0.488 0.744-0.925 1.175-1.075 0.206-0.075 0.444-0.175 0.531-0.225 0.175-0.1 0.938-0.131 0.938-0.038zM13.313 24.994c0 0.031 0.619 0.406 1.369 0.844l1.369 0.794 1.294-0.75c0.712-0.413 1.35-0.8 1.419-0.863 0.094-0.087 0.131-0.094 0.169-0.025 0.031 0.044 0.188 0.163 0.344 0.25l0.288 0.175-1.75 1.006c-0.962 0.556-1.781 1.012-1.813 1.012s-0.206-0.094-0.387-0.206c-0.181-0.119-0.956-0.569-1.725-1.012l-1.394-0.8 0.313-0.175c0.169-0.1 0.325-0.206 0.35-0.244 0.050-0.075 0.156-0.081 0.156-0.006z M17.762 8.519l-0.2 0.206v5.438l0.413 0.4h3.306l0.238-0.194 0.231-0.188v-5.469l-0.413-0.4h-3.375l-0.2 0.206z M6.9 24.95c0.019 0.494 0.031 1.063 0.031 1.269l0.006 0.375 0.831 0.481c4.594 2.644 6.638 3.819 7.306 4.213 0.756 0.444 1.012 0.531 1.15 0.406 0.031-0.031 0.969-0.587 2.087-1.225 1.119-0.644 3.087-1.775 4.375-2.519 1.288-0.738 2.375-1.375 2.419-1.413 0.075-0.069 0.188-2.475 0.113-2.475-0.056 0-2.356 1.306-3.475 1.981-0.369 0.212-0.681 0.394-0.7 0.394s-0.431 0.231-0.913 0.512c-0.488 0.288-1.25 0.731-1.7 0.988s-1.137 0.656-1.531 0.894c-0.394 0.231-0.769 0.419-0.837 0.419-0.063 0-0.481-0.219-0.931-0.488-0.925-0.55-1.594-0.938-2.225-1.281-0.238-0.137-0.631-0.363-0.875-0.512-0.238-0.144-0.731-0.425-1.094-0.625s-0.769-0.438-0.906-0.531c-0.137-0.094-0.463-0.281-0.719-0.419-0.256-0.144-0.887-0.5-1.406-0.794-0.513-0.294-0.956-0.538-0.987-0.538-0.025 0-0.031 0.4-0.019 0.887zM13.488 28.619c0.094 0.063 0.65 0.394 1.231 0.731 0.588 0.331 1.137 0.65 1.231 0.706 0.15 0.087 0.188 0.087 0.313 0.012 0.081-0.050 0.681-0.4 1.331-0.775 0.656-0.375 1.206-0.712 1.231-0.756 0.038-0.050 0.075-0.050 0.156 0.012 0.063 0.038 0.231 0.137 0.381 0.212 0.238 0.125 0.337 0.238 0.212 0.238-0.025 0-0.806 0.438-1.731 0.969s-1.719 0.969-1.762 0.969c-0.050 0-0.15-0.038-0.225-0.087s-0.85-0.5-1.719-1l-1.581-0.906 0.3-0.169c0.162-0.1 0.313-0.2 0.319-0.225 0.037-0.081 0.131-0.056 0.313 0.069z',end:'M24.688 0.662c-0.256 0.15-0.8 0.463-1.206 0.694-0.413 0.231-1.056 0.613-1.438 0.838-0.387 0.225-0.825 0.475-0.981 0.556s-0.556 0.306-0.887 0.506c-0.337 0.206-0.8 0.475-1.031 0.6-0.544 0.306-1.206 0.681-2.163 1.25-0.419 0.25-0.825 0.456-0.9 0.456s-0.463-0.188-0.856-0.425c-0.394-0.231-1.088-0.631-1.537-0.888s-1.137-0.656-1.525-0.881c-0.381-0.231-0.85-0.5-1.037-0.6s-0.594-0.331-0.906-0.513c-1.306-0.769-2.094-1.219-2.531-1.456-0.256-0.137-0.494-0.281-0.525-0.306-0.131-0.119-0.162-0.037-0.162 0.4v0.463l3.075 1.769c1.694 0.975 3.706 2.131 4.463 2.575 0.762 0.438 1.438 0.8 1.513 0.8 0.069 0 0.725-0.344 1.462-0.769 3.031-1.756 6.863-3.956 7.269-4.188 0.244-0.137 0.45-0.256 0.462-0.269 0.050-0.044 0.019-0.863-0.031-0.875-0.031-0.006-0.269 0.113-0.525 0.262z M4.438 11.581v10.206l0.331 0.194c0.175 0.106 0.787 0.462 1.356 0.788 1.219 0.7 3.669 2.106 5.844 3.356 0.863 0.494 2.044 1.175 2.625 1.506 0.588 0.337 1.144 0.669 1.238 0.744 0.175 0.137 0.175 0.137 0.313 0.019 0.075-0.069 0.262-0.194 0.419-0.281 0.256-0.137 2.981-1.7 4.938-2.831 1.413-0.819 5.081-2.925 5.581-3.2l0.481-0.275v-20.431h-1.219c-0.669 0-1.219 0.025-1.219 0.050 0 0.081-1.938 1.262-2.675 1.631-0.15 0.075-0.419 0.231-0.594 0.344-0.181 0.112-0.538 0.319-0.794 0.462-0.256 0.137-0.769 0.431-1.137 0.644-0.375 0.219-1.044 0.612-1.494 0.869-0.444 0.256-1.137 0.656-1.531 0.888-0.394 0.237-0.769 0.425-0.831 0.425s-0.481-0.219-0.931-0.487c-0.45-0.263-1.037-0.606-1.306-0.763-0.744-0.431-1.85-1.063-2.581-1.481-0.363-0.206-0.894-0.513-1.188-0.688s-0.969-0.563-1.5-0.862c-0.531-0.3-1.144-0.656-1.356-0.788l-0.394-0.244h-2.375v10.206zM11.563 8.875v0.5h-3.787l-0.406 0.419 0.037 1.925 1.925 0.019 1.919 0.012v0.938l-1.919 0.012-1.925 0.019-0.037 1.925 0.406 0.419h3.788v1h-4.156l-1.031-1.031v-5.625l1.031-1.031h4.156v0.5zM15.719 11.275l1.75 2.862 0.019-2.881 0.012-2.888 0.969 0.037v7.625l-0.475 0.019c-0.387 0.012-0.488 0-0.563-0.094-0.056-0.063-0.844-1.338-1.75-2.831l-1.65-2.719-0.063 5.625-0.969 0.038v-7.7l0.969 0.037 1.75 2.869zM24.856 8.887l0.519 0.519v5.625l-1.031 1.031h-4.469v-7.688h4.469l0.512 0.512zM13.813 17.625c0 0.031 0.119 0.087 0.269 0.125 0.544 0.137 1.025 0.331 1.5 0.6l0.481 0.275 0.488-0.275c1.806-1.044 3.431-0.731 4.225 0.8 0.194 0.375 0.225 0.488 0.225 0.875 0 0.4-0.031 0.506-0.25 0.956-0.281 0.563-0.631 0.994-1.031 1.269-0.281 0.194-1.087 0.625-1.169 0.625-0.119 0-0.025-0.119 0.256-0.325 0.169-0.125 0.431-0.394 0.587-0.594 0.875-1.144 0.969-2.231 0.244-2.906-0.381-0.356-0.663-0.45-1.325-0.45-0.631 0-1.044 0.087-1.738 0.381l-0.512 0.219-0.55-0.219c-1.281-0.519-2.412-0.55-3.031-0.081-1.106 0.831-0.45 2.581 1.294 3.406 0.481 0.231 1.219 0.425 1.806 0.481 0.531 0.044 0.687-0.012 1.35-0.512 0.512-0.387 0.856-0.825 0.981-1.256 0.313-1.063-0.688-1.462-1.619-0.65l-0.206 0.181-0.275-0.188c-0.406-0.275-0.787-0.425-1.069-0.425-0.319 0-0.456 0.075-0.55 0.3-0.169 0.4 0.2 1.094 0.806 1.519 0.206 0.15 0.35 0.281 0.319 0.294-0.113 0.038-1.262-0.538-1.619-0.806-0.894-0.675-0.925-1.45-0.069-1.887 0.281-0.144 0.425-0.175 0.787-0.175 0.575 0 0.869 0.087 1.275 0.4 0.213 0.156 0.356 0.225 0.4 0.194 0.775-0.6 1.375-0.731 2-0.438 0.606 0.281 0.906 0.712 0.906 1.3-0.006 0.95-0.906 1.794-2.663 2.5-0.281 0.119-0.425 0.137-0.619 0.106-0.137-0.025-0.537-0.094-0.894-0.15-0.781-0.125-1.569-0.387-2.131-0.694-0.531-0.3-1.25-1.019-1.45-1.45-0.081-0.175-0.169-0.325-0.194-0.325-0.031 0-0.050-0.306-0.050-0.681 0-0.619 0.012-0.706 0.169-0.981 0.269-0.488 0.744-0.925 1.175-1.075 0.206-0.075 0.444-0.175 0.531-0.225 0.175-0.1 0.938-0.131 0.938-0.038zM13.313 24.994c0 0.031 0.619 0.406 1.369 0.844l1.369 0.794 1.294-0.75c0.712-0.413 1.35-0.8 1.419-0.863 0.094-0.087 0.131-0.094 0.169-0.025 0.031 0.044 0.188 0.163 0.344 0.25l0.288 0.175-1.75 1.006c-0.962 0.556-1.781 1.012-1.813 1.012s-0.206-0.094-0.387-0.206c-0.181-0.119-0.956-0.569-1.725-1.012l-1.394-0.8 0.313-0.175c0.169-0.1 0.325-0.206 0.35-0.244 0.050-0.075 0.156-0.081 0.156-0.006z M20.875 12.219v2.844h3.1l0.4-0.412v-4.875l-0.413-0.4h-3.087v2.844z M6.9 24.95c0.019 0.494 0.031 1.063 0.031 1.269l0.006 0.375 0.831 0.481c4.594 2.644 6.638 3.819 7.306 4.213 0.756 0.444 1.012 0.531 1.15 0.406 0.031-0.031 0.969-0.587 2.087-1.225 1.119-0.644 3.087-1.775 4.375-2.519 1.288-0.738 2.375-1.375 2.419-1.413 0.075-0.069 0.188-2.475 0.113-2.475-0.056 0-2.356 1.306-3.475 1.981-0.369 0.212-0.681 0.394-0.7 0.394s-0.431 0.231-0.913 0.512c-0.488 0.288-1.25 0.731-1.7 0.988s-1.137 0.656-1.531 0.894c-0.394 0.231-0.769 0.419-0.837 0.419-0.063 0-0.481-0.219-0.931-0.488-0.925-0.55-1.594-0.938-2.225-1.281-0.238-0.137-0.631-0.363-0.875-0.512-0.238-0.144-0.731-0.425-1.094-0.625s-0.769-0.438-0.906-0.531c-0.137-0.094-0.463-0.281-0.719-0.419-0.256-0.144-0.887-0.5-1.406-0.794-0.513-0.294-0.956-0.538-0.987-0.538-0.025 0-0.031 0.4-0.019 0.887zM13.488 28.619c0.094 0.063 0.65 0.394 1.231 0.731 0.588 0.331 1.137 0.65 1.231 0.706 0.15 0.087 0.188 0.087 0.313 0.012 0.081-0.050 0.681-0.4 1.331-0.775 0.656-0.375 1.206-0.712 1.231-0.756 0.038-0.050 0.075-0.050 0.156 0.012 0.063 0.038 0.231 0.137 0.381 0.212 0.238 0.125 0.337 0.238 0.212 0.238-0.025 0-0.806 0.438-1.731 0.969s-1.719 0.969-1.762 0.969c-0.050 0-0.15-0.038-0.225-0.087s-0.85-0.5-1.719-1l-1.581-0.906 0.3-0.169c0.162-0.1 0.313-0.2 0.319-0.225 0.037-0.081 0.131-0.056 0.313 0.069z'
                            },
                            dt:{
                              start:'M13.394 1.769c-1.381 0.969-2.512 1.781-2.519 1.8 0 0.031 1.181 0.731 2.313 1.369 1.044 0.588 2.238 1.281 2.438 1.419 0.281 0.188 0.394 0.181 0.744-0.031 0.325-0.206 0.663-0.4 3.006-1.737 0.906-0.525 1.656-0.975 1.669-1 0.012-0.056-4.944-3.544-5.069-3.569-0.037-0.006-1.2 0.781-2.581 1.75z M9.844 4.269c-1.762 1.231-3.063 2.144-3.394 2.369l-0.344 0.237h-4.294v14.938h1.344c1.306 0 1.35 0.006 1.581 0.15 0.125 0.081 0.725 0.425 1.325 0.775 0.6 0.344 1.825 1.044 2.719 1.556 2.425 1.394 4.619 2.656 5.813 3.337 0.588 0.337 1.144 0.669 1.238 0.744 0.175 0.137 0.175 0.137 0.313 0.019 0.075-0.069 0.262-0.194 0.419-0.281 0.25-0.131 1.212-0.688 5.188-2.975 3.156-1.819 4.894-2.813 5.319-3.056l0.481-0.269h2.7v-14.938h-2.194c-1.325 0-2.238-0.025-2.306-0.063-0.063-0.031-1.113-0.763-2.337-1.619l-2.219-1.556-0.019 0.231c-0.019 0.225-0.031 0.231-1.113 0.856-0.6 0.344-1.762 1.013-2.587 1.487-0.819 0.469-1.519 0.844-1.563 0.831-0.1-0.037-4.994-2.862-5.081-2.931-0.044-0.031-0.081-0.15-0.094-0.263l-0.019-0.2-0.875 0.619zM21.188 4.688c0 0.188-0.031 0.269-0.137 0.338-0.55 0.338-5.075 2.912-5.125 2.912-0.037 0-0.619-0.319-1.294-0.713-0.675-0.388-1.825-1.050-2.55-1.469l-1.331-0.769v-0.25c0-0.213 0.019-0.244 0.113-0.206 0.1 0.037 2 1.112 2.762 1.569 0.188 0.112 0.787 0.456 1.331 0.775l0.994 0.569 0.412-0.244c0.625-0.369 1.494-0.875 1.95-1.138 0.581-0.331 1.175-0.675 2.031-1.175 0.413-0.244 0.769-0.444 0.8-0.444 0.025-0.006 0.044 0.106 0.044 0.244zM14.387 8.544l0.55 0.55v0.906h-1.063v-0.231c0-0.175-0.050-0.281-0.2-0.438l-0.2-0.206h-3.063l-0.412 0.4v5.375l0.463 0.475h2.95l0.231-0.238 0.238-0.238-0.019-1.063-0.019-1.056-1.044-0.019-1.050-0.012v-1.063h3.188v3.719l-1.031 1.031h-3.938l-0.519-0.556-0.512-0.563v-6.225l1.094-1.094h3.813l0.544 0.544zM22.262 8.544l0.55 0.55v6.313l-1.031 1.031h-4.25l-1.094-1.094v-6.256l0.556-0.544 0.55-0.544h4.175l0.544 0.544zM5.313 8.625v0.375h-1.5v2.563h-0.813v-3.313h2.313v0.375zM29.125 9.906v1.656h-0.813v-2.563h-1.5v-0.75h2.313v1.656zM3.813 18.375v1.188h1.5v0.75h-2.313v-3.125h0.813v1.188zM29.125 18.75v1.563h-2.313v-0.75h1.5v-2.375h0.813v1.563zM13.813 17.625c0 0.031 0.119 0.087 0.269 0.125 0.544 0.137 1.025 0.331 1.5 0.6l0.481 0.275 0.488-0.275c1.806-1.044 3.431-0.731 4.225 0.8 0.194 0.375 0.225 0.488 0.225 0.875 0 0.4-0.031 0.506-0.25 0.956-0.281 0.563-0.631 0.994-1.031 1.269-0.281 0.194-1.087 0.625-1.169 0.625-0.119 0-0.025-0.119 0.256-0.325 0.169-0.125 0.431-0.394 0.587-0.594 0.875-1.144 0.969-2.231 0.244-2.906-0.381-0.356-0.663-0.45-1.325-0.45-0.631 0-1.044 0.087-1.738 0.381l-0.512 0.219-0.55-0.219c-1.281-0.519-2.412-0.55-3.031-0.081-1.106 0.831-0.45 2.581 1.294 3.406 0.481 0.231 1.219 0.425 1.806 0.481 0.531 0.044 0.687-0.012 1.35-0.512 0.512-0.387 0.856-0.825 0.981-1.256 0.313-1.063-0.688-1.462-1.619-0.65l-0.206 0.181-0.275-0.188c-0.406-0.275-0.787-0.425-1.069-0.425-0.319 0-0.456 0.075-0.55 0.3-0.169 0.4 0.2 1.094 0.806 1.519 0.206 0.15 0.35 0.281 0.319 0.294-0.113 0.038-1.262-0.538-1.619-0.806-0.894-0.675-0.925-1.45-0.069-1.887 0.281-0.144 0.425-0.175 0.787-0.175 0.575 0 0.869 0.087 1.275 0.4 0.213 0.156 0.356 0.225 0.4 0.194 0.775-0.6 1.375-0.731 2-0.438 0.606 0.281 0.906 0.712 0.906 1.3-0.006 0.95-0.906 1.794-2.663 2.5-0.281 0.119-0.425 0.137-0.619 0.106-0.137-0.025-0.537-0.094-0.894-0.15-0.781-0.125-1.569-0.387-2.131-0.694-0.531-0.3-1.25-1.019-1.45-1.45-0.081-0.175-0.169-0.325-0.194-0.325-0.031 0-0.050-0.306-0.050-0.681 0-0.619 0.012-0.706 0.169-0.981 0.269-0.488 0.744-0.925 1.175-1.075 0.206-0.075 0.444-0.175 0.531-0.225 0.175-0.1 0.938-0.131 0.938-0.038zM13.313 24.994c0 0.031 0.619 0.406 1.369 0.844l1.369 0.794 1.294-0.75c0.712-0.413 1.35-0.8 1.419-0.863 0.094-0.087 0.131-0.094 0.169-0.025 0.031 0.044 0.188 0.163 0.344 0.25l0.288 0.175-1.75 1.006c-0.962 0.556-1.781 1.012-1.813 1.012s-0.206-0.094-0.387-0.206c-0.181-0.119-0.956-0.569-1.725-1.012l-1.394-0.8 0.313-0.175c0.169-0.1 0.325-0.206 0.35-0.244 0.050-0.075 0.156-0.081 0.156-0.006z M17.762 9.331l-0.2 0.206v5.438l0.413 0.4h3.306l0.238-0.194 0.231-0.188v-5.469l-0.413-0.4h-3.375l-0.2 0.206z M6.9 24.95c0.019 0.494 0.031 1.063 0.031 1.269l0.006 0.375 0.831 0.481c4.594 2.644 6.638 3.819 7.306 4.213 0.756 0.444 1.012 0.531 1.15 0.406 0.031-0.031 0.969-0.587 2.087-1.225 1.119-0.644 3.087-1.775 4.375-2.519 1.288-0.738 2.375-1.375 2.419-1.413 0.075-0.069 0.188-2.475 0.113-2.475-0.056 0-2.356 1.306-3.475 1.981-0.369 0.212-0.681 0.394-0.7 0.394s-0.431 0.231-0.913 0.512c-0.488 0.288-1.25 0.731-1.7 0.988s-1.137 0.656-1.531 0.894c-0.394 0.231-0.769 0.419-0.837 0.419-0.063 0-0.481-0.219-0.931-0.488-0.925-0.55-1.594-0.938-2.225-1.281-0.238-0.137-0.631-0.363-0.875-0.512-0.238-0.144-0.731-0.425-1.094-0.625s-0.769-0.438-0.906-0.531c-0.137-0.094-0.463-0.281-0.719-0.419-0.256-0.144-0.887-0.5-1.406-0.794-0.513-0.294-0.956-0.538-0.987-0.538-0.025 0-0.031 0.4-0.019 0.887zM13.488 28.619c0.094 0.063 0.65 0.394 1.231 0.731 0.588 0.331 1.137 0.65 1.231 0.706 0.15 0.087 0.188 0.087 0.313 0.012 0.081-0.050 0.681-0.4 1.331-0.775 0.656-0.375 1.206-0.712 1.231-0.756 0.038-0.050 0.075-0.050 0.156 0.012 0.063 0.038 0.231 0.137 0.381 0.212 0.238 0.125 0.337 0.238 0.212 0.238-0.025 0-0.806 0.438-1.731 0.969s-1.719 0.969-1.762 0.969c-0.050 0-0.15-0.038-0.225-0.087s-0.85-0.5-1.719-1l-1.581-0.906 0.3-0.169c0.162-0.1 0.313-0.2 0.319-0.225 0.037-0.081 0.131-0.056 0.313 0.069z',end:'M13.394 1.769c-1.381 0.969-2.512 1.781-2.519 1.8 0 0.031 1.181 0.731 2.313 1.369 1.044 0.588 2.238 1.281 2.438 1.419 0.281 0.188 0.394 0.181 0.744-0.031 0.325-0.206 0.663-0.4 3.006-1.737 0.906-0.525 1.656-0.975 1.669-1 0.012-0.056-4.944-3.544-5.069-3.569-0.037-0.006-1.2 0.781-2.581 1.75z M9.844 4.269c-1.762 1.231-3.063 2.144-3.394 2.369l-0.344 0.237h-4.294v14.938h1.344c1.306 0 1.35 0.006 1.581 0.15 0.125 0.081 0.725 0.425 1.325 0.775 0.6 0.344 1.825 1.044 2.719 1.556 2.425 1.394 4.619 2.656 5.813 3.337 0.588 0.337 1.144 0.669 1.238 0.744 0.175 0.137 0.175 0.137 0.313 0.019 0.075-0.069 0.262-0.194 0.419-0.281 0.25-0.131 1.212-0.688 5.188-2.975 3.156-1.819 4.894-2.813 5.319-3.056l0.481-0.269h2.7v-14.938h-2.194c-1.325 0-2.238-0.025-2.306-0.063-0.063-0.031-1.113-0.763-2.337-1.619l-2.219-1.556-0.019 0.231c-0.019 0.225-0.031 0.231-1.113 0.856-0.6 0.344-1.762 1.013-2.587 1.487-0.819 0.469-1.519 0.844-1.563 0.831-0.1-0.037-4.994-2.862-5.081-2.931-0.044-0.031-0.081-0.15-0.094-0.263l-0.019-0.2-0.875 0.619zM21.188 4.688c0 0.188-0.031 0.269-0.137 0.338-0.55 0.338-5.075 2.912-5.125 2.912-0.037 0-0.619-0.319-1.294-0.713-0.675-0.388-1.825-1.050-2.55-1.469l-1.331-0.769v-0.25c0-0.213 0.019-0.244 0.113-0.206 0.1 0.037 2 1.112 2.762 1.569 0.188 0.112 0.787 0.456 1.331 0.775l0.994 0.569 0.412-0.244c0.625-0.369 1.494-0.875 1.95-1.138 0.581-0.331 1.175-0.675 2.031-1.175 0.413-0.244 0.769-0.444 0.8-0.444 0.025-0.006 0.044 0.106 0.044 0.244zM5.313 8.625v0.375h-1.5v2.563h-0.813v-3.313h2.313v0.375zM29.125 9.906v1.656h-0.813v-2.563h-1.5v-0.75h2.313v1.656zM11.625 9.469v0.469h-3.725l-0.169 0.175c-0.169 0.175-0.169 0.175-0.169 1.156v0.981h3.75v0.938h-3.75v1.975l0.35 0.338h3.719l-0.019 0.481-0.019 0.488-2 0.019-1.994 0.012-0.487-0.481-0.487-0.488v-5.625l0.45-0.45 0.45-0.456h4.1v0.469zM15.625 11.762l1.656 2.756 0.019-2.763 0.012-2.756h1l-0.012 3.731-0.019 3.738-0.425 0.019c-0.238 0.012-0.462-0.012-0.506-0.044-0.044-0.038-0.819-1.3-1.731-2.813l-1.65-2.744-0.019 2.806-0.012 2.806h-0.938v-7.5h0.488l0.481 0.006 1.656 2.756zM24.512 9.481l0.488 0.488v5.563l-0.488 0.488-0.488 0.481-2.181-0.012-2.188-0.019-0.019-3.738-0.012-3.731h4.406l0.481 0.481zM3.813 18.375v1.188h1.5v0.75h-2.313v-3.125h0.813v1.188zM29.125 18.75v1.563h-2.313v-0.75h1.5v-2.375h0.813v1.563zM13.813 17.625c0 0.031 0.119 0.087 0.269 0.125 0.544 0.137 1.025 0.331 1.5 0.6l0.481 0.275 0.488-0.275c1.806-1.044 3.431-0.731 4.225 0.8 0.194 0.375 0.225 0.488 0.225 0.875 0 0.4-0.031 0.506-0.25 0.956-0.281 0.563-0.631 0.994-1.031 1.269-0.281 0.194-1.087 0.625-1.169 0.625-0.119 0-0.025-0.119 0.256-0.325 0.169-0.125 0.431-0.394 0.587-0.594 0.875-1.144 0.969-2.231 0.244-2.906-0.381-0.356-0.663-0.45-1.325-0.45-0.631 0-1.044 0.087-1.738 0.381l-0.512 0.219-0.55-0.219c-1.281-0.519-2.412-0.55-3.031-0.081-1.106 0.831-0.45 2.581 1.294 3.406 0.481 0.231 1.219 0.425 1.806 0.481 0.531 0.044 0.687-0.012 1.35-0.512 0.512-0.387 0.856-0.825 0.981-1.256 0.313-1.063-0.688-1.462-1.619-0.65l-0.206 0.181-0.275-0.188c-0.406-0.275-0.787-0.425-1.069-0.425-0.319 0-0.456 0.075-0.55 0.3-0.169 0.4 0.2 1.094 0.806 1.519 0.206 0.15 0.35 0.281 0.319 0.294-0.113 0.038-1.262-0.538-1.619-0.806-0.894-0.675-0.925-1.45-0.069-1.887 0.281-0.144 0.425-0.175 0.787-0.175 0.575 0 0.869 0.087 1.275 0.4 0.213 0.156 0.356 0.225 0.4 0.194 0.775-0.6 1.375-0.731 2-0.438 0.606 0.281 0.906 0.712 0.906 1.3-0.006 0.95-0.906 1.794-2.663 2.5-0.281 0.119-0.425 0.137-0.619 0.106-0.137-0.025-0.537-0.094-0.894-0.15-0.781-0.125-1.569-0.387-2.131-0.694-0.531-0.3-1.25-1.019-1.45-1.45-0.081-0.175-0.169-0.325-0.194-0.325-0.031 0-0.050-0.306-0.050-0.681 0-0.619 0.012-0.706 0.169-0.981 0.269-0.488 0.744-0.925 1.175-1.075 0.206-0.075 0.444-0.175 0.531-0.225 0.175-0.1 0.938-0.131 0.938-0.038zM13.313 24.994c0 0.031 0.619 0.406 1.369 0.844l1.369 0.794 1.294-0.75c0.712-0.413 1.35-0.8 1.419-0.863 0.094-0.087 0.131-0.094 0.169-0.025 0.031 0.044 0.188 0.163 0.344 0.25l0.288 0.175-1.75 1.006c-0.962 0.556-1.781 1.012-1.813 1.012s-0.206-0.094-0.387-0.206c-0.181-0.119-0.956-0.569-1.725-1.012l-1.394-0.8 0.313-0.175c0.169-0.1 0.325-0.206 0.35-0.244 0.050-0.075 0.156-0.081 0.156-0.006z M20.625 12.719v2.781h3.038l0.337-0.35v-4.862l-0.337-0.35h-3.038v2.781z M6.9 24.95c0.019 0.494 0.031 1.063 0.031 1.269l0.006 0.375 0.831 0.481c4.594 2.644 6.638 3.819 7.306 4.213 0.756 0.444 1.012 0.531 1.15 0.406 0.031-0.031 0.969-0.587 2.087-1.225 1.119-0.644 3.087-1.775 4.375-2.519 1.288-0.738 2.375-1.375 2.419-1.413 0.075-0.069 0.188-2.475 0.113-2.475-0.056 0-2.356 1.306-3.475 1.981-0.369 0.212-0.681 0.394-0.7 0.394s-0.431 0.231-0.913 0.512c-0.488 0.288-1.25 0.731-1.7 0.988s-1.137 0.656-1.531 0.894c-0.394 0.231-0.769 0.419-0.837 0.419-0.063 0-0.481-0.219-0.931-0.488-0.925-0.55-1.594-0.938-2.225-1.281-0.238-0.137-0.631-0.363-0.875-0.512-0.238-0.144-0.731-0.425-1.094-0.625s-0.769-0.438-0.906-0.531c-0.137-0.094-0.463-0.281-0.719-0.419-0.256-0.144-0.887-0.5-1.406-0.794-0.513-0.294-0.956-0.538-0.987-0.538-0.025 0-0.031 0.4-0.019 0.887zM13.488 28.619c0.094 0.063 0.65 0.394 1.231 0.731 0.588 0.331 1.137 0.65 1.231 0.706 0.15 0.087 0.188 0.087 0.313 0.012 0.081-0.050 0.681-0.4 1.331-0.775 0.656-0.375 1.206-0.712 1.231-0.756 0.038-0.050 0.075-0.050 0.156 0.012 0.063 0.038 0.231 0.137 0.381 0.212 0.238 0.125 0.337 0.238 0.212 0.238-0.025 0-0.806 0.438-1.731 0.969s-1.719 0.969-1.762 0.969c-0.050 0-0.15-0.038-0.225-0.087s-0.85-0.5-1.719-1l-1.581-0.906 0.3-0.169c0.162-0.1 0.313-0.2 0.319-0.225 0.037-0.081 0.131-0.056 0.313 0.069z'
                            },wm:{
                              start:'M13.925 0.087c-0.95 0.269-1.613 0.9-1.931 1.831-0.119 0.356-0.125 0.506-0.106 3.744l0.019 3.375 0.238 0.475c0.162 0.338 0.338 0.575 0.613 0.825 0.206 0.194 0.4 0.35 0.438 0.35 0.031 0 0.056 0.381 0.056 0.9v0.9l-0.394 0.35c-1.494 1.306-4.119 2.613-7.181 3.569l-0.737 0.231v5.519l0.456 0.256c0.244 0.137 1.225 0.7 2.169 1.244s2.237 1.294 2.875 1.656c1.875 1.081 3.681 2.119 4.281 2.469 0.313 0.181 0.675 0.394 0.813 0.469 0.137 0.081 0.3 0.188 0.363 0.238 0.094 0.081 0.119 0.081 0.219 0 0.056-0.050 0.219-0.156 0.356-0.238 0.137-0.075 0.506-0.288 0.813-0.469 0.6-0.35 2.406-1.387 4.281-2.469 0.637-0.363 1.931-1.113 2.875-1.656s1.925-1.106 2.169-1.244l0.456-0.256v-5.512l-1.169-0.387c-2.769-0.912-5.137-2.119-6.613-3.363l-0.438-0.369-0.038-1.787 0.413-0.375c0.3-0.275 0.462-0.494 0.637-0.85l0.238-0.475 0.019-3.369c0.019-3.256 0.012-3.388-0.113-3.756-0.256-0.769-0.813-1.369-1.6-1.719l-0.369-0.163-1.906-0.013c-1.425-0.006-1.981 0.006-2.2 0.069zM14.7 15.919l0.425 0.419v0.725h-0.406c-0.4 0-0.406 0-0.406-0.169 0-0.1-0.069-0.244-0.169-0.344l-0.169-0.175h-2.387l-0.338 0.35v4.238l0.338 0.35h2.387l0.169-0.175c0.175-0.181 0.175-0.181 0.156-1.019l-0.019-0.837-1.656-0.038v-0.806h2.5v2.962l-0.775 0.788h-3.15l-0.381-0.406-0.381-0.413v-5.019l0.838-0.85h3l0.425 0.419zM20.95 15.919l0.425 0.419v5l-0.837 0.85h-3.313l-0.85-0.837v-5l0.837-0.85h3.313l0.425 0.419zM13.45 25.238c0.025 0.069 2.525 1.512 2.613 1.512 0.044 0 0.15-0.050 0.238-0.113 0.094-0.063 0.631-0.381 1.2-0.7s1.081-0.625 1.144-0.681c0.075-0.063 0.131-0.075 0.156-0.031 0.025 0.038 0.163 0.131 0.313 0.212 0.144 0.081 0.262 0.163 0.262 0.181-0.006 0.050-3.269 1.913-3.35 1.913s-3.331-1.863-3.338-1.906c0-0.019 0.125-0.1 0.281-0.188s0.281-0.175 0.281-0.2c0-0.063 0.169-0.063 0.2 0z M17.387 16.519c-0.137 0.144-0.137 0.175-0.137 2.331v2.194l0.144 0.131c0.137 0.131 0.194 0.137 1.488 0.137 1.325 0 1.35 0 1.481-0.144 0.137-0.144 0.137-0.175 0.137-2.331v-2.194l-0.144-0.131c-0.137-0.131-0.194-0.137-1.488-0.137-1.325 0-1.35 0-1.481 0.144z M7.3 24.694c-0.006 0.206-0.013 0.75 0 1.212l0.019 0.837 4.256 2.456c2.344 1.35 4.313 2.462 4.375 2.475s1.144-0.575 2.475-1.337c3.444-1.988 4.963-2.863 5.706-3.294l0.663-0.381 0.038-1.156c0.025-0.631 0.031-1.163 0.019-1.181-0.031-0.025-1.481 0.775-1.788 0.988-0.087 0.056-0.337 0.2-0.563 0.319-0.225 0.113-0.669 0.375-0.988 0.569-0.319 0.2-0.6 0.363-0.619 0.363s-0.4 0.212-0.856 0.475c-0.45 0.262-1.156 0.675-1.569 0.913-0.413 0.244-1.106 0.644-1.538 0.9-0.438 0.256-0.819 0.462-0.856 0.462-0.031 0-0.225-0.094-0.425-0.212-0.206-0.119-0.55-0.325-0.775-0.45-0.931-0.531-2.588-1.494-4.088-2.369-0.338-0.2-0.9-0.519-1.25-0.719-0.35-0.194-0.925-0.525-1.287-0.731-1.037-0.594-0.925-0.575-0.95-0.137zM13.512 28.613c0.025 0.069 2.525 1.512 2.613 1.512 0.044 0 0.15-0.050 0.238-0.113 0.094-0.063 0.631-0.381 1.2-0.7s1.081-0.625 1.144-0.681c0.075-0.063 0.131-0.075 0.156-0.031 0.025 0.038 0.163 0.131 0.313 0.212 0.144 0.081 0.262 0.163 0.262 0.181-0.006 0.050-3.269 1.913-3.35 1.913s-3.331-1.863-3.338-1.906c0-0.019 0.125-0.1 0.281-0.188s0.281-0.175 0.281-0.2c0-0.063 0.169-0.063 0.2 0z',end:'M13.925 0.087c-0.95 0.269-1.613 0.9-1.931 1.831-0.119 0.356-0.125 0.506-0.106 3.744l0.019 3.375 0.238 0.475c0.162 0.338 0.338 0.575 0.613 0.825 0.206 0.194 0.4 0.35 0.438 0.35 0.031 0 0.056 0.381 0.056 0.9v0.9l-0.394 0.35c-1.494 1.306-4.119 2.613-7.181 3.569l-0.737 0.231v5.519l0.456 0.256c0.244 0.137 1.225 0.7 2.169 1.244s2.237 1.294 2.875 1.656c1.875 1.081 3.681 2.119 4.281 2.469 0.313 0.181 0.675 0.394 0.813 0.469 0.137 0.081 0.3 0.188 0.363 0.238 0.094 0.081 0.119 0.081 0.219 0 0.056-0.050 0.219-0.156 0.356-0.238 0.137-0.075 0.506-0.288 0.813-0.469 0.6-0.35 2.406-1.387 4.281-2.469 0.637-0.363 1.931-1.113 2.875-1.656s1.925-1.106 2.169-1.244l0.456-0.256v-5.512l-1.169-0.387c-2.769-0.912-5.137-2.119-6.613-3.363l-0.438-0.369-0.038-1.787 0.413-0.375c0.3-0.275 0.462-0.494 0.637-0.85l0.238-0.475 0.019-3.369c0.019-3.256 0.012-3.388-0.113-3.756-0.256-0.769-0.813-1.369-1.6-1.719l-0.369-0.163-1.906-0.013c-1.425-0.006-1.981 0.006-2.2 0.069zM12.675 16.481l-0.019 0.363-1.438 0.019c-1.819 0.019-1.719-0.038-1.719 1.025v0.738l1.456 0.012 1.45 0.019v0.75l-1.45 0.019-1.456 0.012v0.775c0 0.663 0.019 0.781 0.113 0.869 0.1 0.087 0.325 0.106 1.581 0.119l1.463 0.019v0.75l-1.594 0.019-1.588 0.012-0.725-0.712v-4.438l0.713-0.725h3.231l-0.019 0.356zM15.806 18.288l1.287 2.125 0.019-2.144 0.012-2.144h0.813l-0.012 2.919-0.019 2.925-0.75 0.038-1.313-2.181-1.313-2.175-0.031 2.156-0.031 2.163-0.719 0.038v-5.887l0.769 0.038 1.287 2.131zM22.769 16.488l0.356 0.363v4.375l-0.788 0.775-1.681-0.012-1.688-0.019-0.019-2.925-0.012-2.919h3.475l0.356 0.363zM13.45 25.238c0.025 0.069 2.525 1.512 2.613 1.512 0.044 0 0.15-0.050 0.238-0.113 0.094-0.063 0.631-0.381 1.2-0.7s1.081-0.625 1.144-0.681c0.075-0.063 0.131-0.075 0.156-0.031 0.025 0.038 0.163 0.131 0.313 0.212 0.144 0.081 0.262 0.163 0.262 0.181-0.006 0.050-3.269 1.913-3.35 1.913s-3.331-1.863-3.338-1.906c0-0.019 0.125-0.1 0.281-0.188s0.281-0.175 0.281-0.2c0-0.063 0.169-0.063 0.2 0z M19.75 19.031v2.156h1.175c1.15 0 1.181-0.006 1.313-0.144 0.137-0.144 0.137-0.181 0.137-2.019v-1.881l-0.144-0.131c-0.137-0.131-0.2-0.137-1.313-0.137h-1.169v2.156z M7.3 24.694c-0.006 0.206-0.013 0.75 0 1.212l0.019 0.837 4.256 2.456c2.344 1.35 4.313 2.462 4.375 2.475s1.144-0.575 2.475-1.337c3.444-1.988 4.963-2.863 5.706-3.294l0.663-0.381 0.038-1.156c0.025-0.631 0.031-1.163 0.019-1.181-0.031-0.025-1.481 0.775-1.788 0.988-0.087 0.056-0.337 0.2-0.563 0.319-0.225 0.113-0.669 0.375-0.988 0.569-0.319 0.2-0.6 0.363-0.619 0.363s-0.4 0.212-0.856 0.475c-0.45 0.262-1.156 0.675-1.569 0.913-0.413 0.244-1.106 0.644-1.538 0.9-0.438 0.256-0.819 0.462-0.856 0.462-0.031 0-0.225-0.094-0.425-0.212-0.206-0.119-0.55-0.325-0.775-0.45-0.931-0.531-2.588-1.494-4.088-2.369-0.338-0.2-0.9-0.519-1.25-0.719-0.35-0.194-0.925-0.525-1.287-0.731-1.037-0.594-0.925-0.575-0.95-0.137zM13.512 28.613c0.025 0.069 2.525 1.512 2.613 1.512 0.044 0 0.15-0.050 0.238-0.113 0.094-0.063 0.631-0.381 1.2-0.7s1.081-0.625 1.144-0.681c0.075-0.063 0.131-0.075 0.156-0.031 0.025 0.038 0.163 0.131 0.313 0.212 0.144 0.081 0.262 0.163 0.262 0.181-0.006 0.050-3.269 1.913-3.35 1.913s-3.331-1.863-3.338-1.906c0-0.019 0.125-0.1 0.281-0.188s0.281-0.175 0.281-0.2c0-0.063 0.169-0.063 0.2 0z'
                            }
                          },
                          data:{
                            frequency:'hour',
                            time:{
                              start:360,
                              end:1080
                            },
                            region: [],
                            province: [],
                            district: [],
                            dts:[],
                            minis:[],
                            wms:[],
                            filter:{
                              options:{
                                dts:[],
                                minis:[],
                                wms:[]
                              },
                              dts:[],
                              minis:[],
                              wms:[]
                            },
                            poi:[]
                          },
                          options:{
                            frequency:[{id:'minute',label:'1 นาที'},{id:'hour',label:'1 ชั่วโมง'}],
                            time:{
                              start:[{id:0,label:'00:00'},{id:15,label:'00:15'},{id:30,label:'00:30'},{id:45,label:'00:45'},{id:60,label:'01:00'},{id:75,label:'01:15'},{id:90,label:'01:30'},{id:105,label:'01:45'},{id:120,label:'02:00'},{id:135,label:'02:15'},{id:150,label:'02:30'},{id:165,label:'02:45'},{id:180,label:'03:00'},{id:195,label:'03:15'},{id:210,label:'03:30'},{id:225,label:'03:45'},{id:240,label:'04:00'},{id:255,label:'04:15'},{id:270,label:'04:30'},{id:285,label:'04:45'},{id:300,label:'05:00'},{id:315,label:'05:15'},{id:330,label:'05:30'},{id:345,label:'05:45'},{id:360,label:'06:00'},{id:375,label:'06:15'},{id:390,label:'06:30'},{id:405,label:'06:45'},{id:420,label:'07:00'},{id:435,label:'07:15'},{id:450,label:'07:30'},{id:465,label:'07:45'},{id:480,label:'08:00'},{id:495,label:'08:15'},{id:510,label:'08:30'},{id:525,label:'08:45'},{id:540,label:'09:00'},{id:555,label:'09:15'},{id:570,label:'09:30'},{id:585,label:'09:45'},{id:600,label:'10:00'},{id:615,label:'10:15'},{id:630,label:'10:30'},{id:645,label:'10:45'},{id:660,label:'11:00'},{id:675,label:'11:15'},{id:690,label:'11:30'},{id:705,label:'11:45'},{id:720,label:'12:00'},{id:735,label:'12:15'},{id:750,label:'12:30'},{id:765,label:'12:45'},{id:780,label:'13:00'},{id:795,label:'13:15'},{id:810,label:'13:30'},{id:825,label:'13:45'},{id:840,label:'14:00'},{id:855,label:'14:15'},{id:870,label:'14:30'},{id:885,label:'14:45'},{id:900,label:'15:00'},{id:915,label:'15:15'},{id:930,label:'15:30'},{id:945,label:'15:45'},{id:960,label:'16:00'},{id:975,label:'16:15'},{id:990,label:'16:30'},{id:1005,label:'16:45'},{id:1020,label:'17:00'},{id:1035,label:'17:15'},{id:1050,label:'17:30'},{id:1065,label:'17:45'},{id:1080,label:'18:00'},{id:1095,label:'18:15'},{id:1110,label:'18:30'},{id:1125,label:'18:45'},{id:1140,label:'19:00'},{id:1155,label:'19:15'},{id:1170,label:'19:30'},{id:1185,label:'19:45'},{id:1200,label:'20:00'},{id:1215,label:'20:15'},{id:1230,label:'20:30'},{id:1245,label:'20:45'},{id:1260,label:'21:00'},{id:1275,label:'21:15'},{id:1290,label:'21:30'},{id:1305,label:'21:45'},{id:1320,label:'22:00'},{id:1335,label:'22:15'},{id:1350,label:'22:30'},{id:1365,label:'22:45'},{id:1380,label:'23:00'},{id:1395,label:'23:15'},{id:1410,label:'23:30'},{id:1425,label:'23:45'}],
                              end:[{id:375,label:'06:15'},{id:390,label:'06:30'},{id:405,label:'06:45'},{id:420,label:'07:00'},{id:435,label:'07:15'},{id:450,label:'07:30'},{id:465,label:'07:45'},{id:480,label:'08:00'},{id:495,label:'08:15'},{id:510,label:'08:30'},{id:525,label:'08:45'},{id:540,label:'09:00'},{id:555,label:'09:15'},{id:570,label:'09:30'},{id:585,label:'09:45'},{id:600,label:'10:00'},{id:615,label:'10:15'},{id:630,label:'10:30'},{id:645,label:'10:45'},{id:660,label:'11:00'},{id:675,label:'11:15'},{id:690,label:'11:30'},{id:705,label:'11:45'},{id:720,label:'12:00'},{id:735,label:'12:15'},{id:750,label:'12:30'},{id:765,label:'12:45'},{id:780,label:'13:00'},{id:795,label:'13:15'},{id:810,label:'13:30'},{id:825,label:'13:45'},{id:840,label:'14:00'},{id:855,label:'14:15'},{id:870,label:'14:30'},{id:885,label:'14:45'},{id:900,label:'15:00'},{id:915,label:'15:15'},{id:930,label:'15:30'},{id:945,label:'15:45'},{id:960,label:'16:00'},{id:975,label:'16:15'},{id:990,label:'16:30'},{id:1005,label:'16:45'},{id:1020,label:'17:00'},{id:1035,label:'17:15'},{id:1050,label:'17:30'},{id:1065,label:'17:45'},{id:1080,label:'18:00'},{id:1095,label:'18:15'},{id:1110,label:'18:30'},{id:1125,label:'18:45'},{id:1140,label:'19:00'},{id:1155,label:'19:15'},{id:1170,label:'19:30'},{id:1185,label:'19:45'},{id:1200,label:'20:00'},{id:1215,label:'20:15'},{id:1230,label:'20:30'},{id:1245,label:'20:45'},{id:1260,label:'21:00'},{id:1275,label:'21:15'},{id:1290,label:'21:30'},{id:1305,label:'21:45'},{id:1320,label:'22:00'},{id:1335,label:'22:15'},{id:1350,label:'22:30'},{id:1365,label:'22:45'},{id:1380,label:'23:00'},{id:1395,label:'23:15'},{id:1410,label:'23:30'},{id:1425,label:'23:45'},{id:1440,label:'24:00'}]
                            },
                            poi:[{id:'attraction',label:'สถานที่ท่องเที่ยว'},{id:'business',label:'สถานที่ธุรกิจ'},{id:'medical',label:'โรงพยาบาล'},{id:'place_of_worship',label:'วัด/โบสถ์/มัสสะยิด'},{id:'government',label:'สถานที่ราชการ'},{id:'school',label:'โรงเรียน/มหาวิทยาลัย'}],
                            region:[{id:'central',label:'ภาคกลาง',children:[{id:1,label:'กรุงเทพมหานคร'},{id:2,label:'สมุทรปราการ'},{id:3,label:'นนทบุรี'},{id:4,label:'ปทุมธานี'},{id:5,label:'พระนครศรีอยุธยา'},{id:6,label:'อ่างทอง'},{id:7,label:'ลพบุรี'},{id:8,label:'สิงห์บุรี'},{id:9,label:'ชัยนาท'},{id:59,label:'นครปฐม'},{id:61,label:'สมุทรสงคราม'},{id:60,label:'สมุทรสาคร'},{id:49,label:'อุทัยธานี'},{id:48,label:'นครสวรรค์'},{id:54,label:'พิจิตร'},{id:58,label:'สุพรรณบุรี'},{id:10,label:'สระบุรี'},{id:50,label:'กำแพงเพชร'},{id:17,label:'นครนายก'},{id:55,label:'เพชรบูรณ์'},{id:53,label:'พิษณุโลก'},{id:52,label:'สุโขทัย'}]},{id:'west',label:'ภาคตะวันตก',children:[{id:57,label:'กาญจนบุรี'},{id:56,label:'ราชบุรี'},{id:62,label:'เพชรบุรี'},{id:63,label:'ประจวบคีรีขันธ์'},{id:51,label:'ตาก'}]},{id:'east',label:'ภาคตะวันออก',children:[{id:12,label:'ระยอง'},{id:15,label:'ฉะเชิงเทรา'},{id:11,label:'ชลบุรี'},{id:18,label:'สระแก้ว'},{id:13,label:'จันทบุรี'},{id:16,label:'ปราจีนบุรี'},{id:14,label:'ตราด'}]},{id:'north',label:'ภาคเหนือ',children:[{id:45,label:'พะเยา'},{id:43,label:'แพร่'},{id:47,label:'แม่ฮ่องสอน'},{id:40,label:'ลำพูน'},{id:42,label:'อุตรดิตถ์'},{id:46,label:'เชียงราย'},{id:39,label:'เชียงใหม่'},{id:44,label:'น่าน'},{id:41,label:'ลำปาง'}]},{id:'north_east',label:'ภาคตะวันออกเฉียงเหนือ',children:[{id:29,label:'ขอนแก่น'},{id:28,label:'หนองบัวลำภู'},{id:27,label:'บึงกาฬ'},{id:24,label:'ยโสธร'},{id:25,label:'ชัยภูมิ'},{id:33,label:'มหาสารคาม'},{id:38,label:'มุกดาหาร'},{id:31,label:'เลย'},{id:26,label:'อำนาจเจริญ'},{id:35,label:'กาฬสินธุ์'},{id:37,label:'นครพนม'},{id:34,label:'ร้อยเอ็ด'},{id:22,label:'ศรีสะเกษ'},{id:32,label:'หนองคาย'},{id:36,label:'สกลนคร'},{id:21,label:'สุรินทร์'},{id:19,label:'นครราชสีมา'},{id:20,label:'บุรีรัมย์'},{id:30,label:'อุดรธานี'},{id:23,label:'อุบลราชธานี'}]},{id:'southern',label:'ภาคใต้',children:[{id:69,label:'ระนอง'},{id:68,label:'สุราษฎร์ธานี'},{id:77,label:'นราธิวาส'},{id:74,label:'พัทลุง'},{id:75,label:'ปัตตานี'},{id:76,label:'ยะลา'},{id:64,label:'นครศรีธรรมราช'},{id:67,label:'ภูเก็ต'},{id:71,label:'สงขลา'},{id:70,label:'ชุมพร'},{id:72,label:'สตูล'},{id:73,label:'ตรัง'},{id:65,label:'กระบี่'},{id:66,label:'พังงา'}]}],
                            province:[],
                            district:[],
                            dts:[],
                            minis:[],
                            wms:[],
                            filter:{
                              active:false,
                              options:[{id:'line',label:'เส้นทางการวิ่ง'},{id:'point',label:'จุดตามเวลา'},{id:'polygon',label:'ขอบเขตการวิ่ง'}],
                              wms:[],
                              dts:[],
                              minis:[]
                            }
                          },
                          placeholder:{
                            province:'เลือกภูมิภาค/จังหวัด...',
                            district:'กรุณาเลือกแขวง/อำเภอ...'
                          },
                          table: {
                            rows: [],
                            config: {
                              per_page: 15,
                              per_page_options: [15, 25, 50, 75, 100],
                              card_title: 'รายละเอียดของศูนย์จัดจำหน่าย/มินิ/วอลล์แมน',
                              show_reset_button:false,
                              show_refresh_button: false,
                              global_search: {
                                placeholder: "ค้นหา..."
                              }
                            },
                            columns: [{
                              label: "รหัสพื้นที่การขาย",
                              name: "code",
                              sort: true
                            },{
                              label: "DT",
                              name: "dt",
                              sort: true
                            },{
                              label: "รหัสศูนย์กระจายสินค้า",
                              name: "dt_code",
                              sort: true
                            },{
                              label: "ชื่อศูนย์กระจายสินค้า",
                              name: "dt_name",
                              sort: true
                            },{
                              label: "MINI",
                              name: "mini",
                              sort: true
                            },{
                              label: "รหัสมินิ",
                              name: "mini_code",
                              sort: true
                            },{
                              label: "ชื่อมินิ",
                              name: "mini_name",
                              sort: true
                            },{
                              label: "WM",
                              name: "wm",
                              sort: true
                            },{
                              label: "รหัสวอลล์แมน/วอลล์เลดี้",
                              name: "wm_code",
                              sort: true
                            },{
                              label: "บาร์โค้ดรถมอเตอร์ไซค์",
                              name: "barcode",
                              sort: true
                            },{
                              label: "ชื่อ - นามสกุล",
                              name: "full_name",
                              sort: true
                            }]
                          },
                          json:{
                            province:{},
                            district:{},
                            subdistrict:{},
                            wms:{}
                          },
                          alert: {
                            message: ''
                          },
                          load: {
                            text: '',
                            task: 0,
                            count: 0,
                            percent: 0,
                            active: false
                          },
                          map:{
                            body: null,
                            styles:[{
                              elementType: 'geometry',
                              stylers: [{color:'#f5f5f5'}]
                            },{
                              elementType: 'labels.icon',
                              stylers: [{visibility:'off'}]
                            },{
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#616161'}]
                            },{
                              elementType: 'labels.text.stroke',
                              stylers: [{color: '#f5f5f5'}]
                            },{
                              featureType: 'administrative.land_parcel',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#bdbdbd'}]
                            },{
                              featureType: 'poi',
                              elementType: 'geometry',
                              stylers: [{color: '#eeeeee'}]
                            },{
                              featureType: 'poi',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#757575'}]
                            },{
                              featureType: 'poi.park',
                              elementType: 'geometry',
                              stylers: [{color: '#e5e5e5'}]
                            },{
                              featureType: 'poi.park',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#9e9e9e'}]
                            },{
                              featureType: 'road',
                              elementType: 'geometry',
                              stylers: [{color: '#c5c5c5'}]
                            },{
                              featureType: 'road.arterial',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#757575'}]
                            },{
                              featureType: 'road.highway',
                              elementType: 'geometry',
                              stylers: [{color: '#dadada'}]
                            },{
                              featureType: 'road.highway',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#616161'}]
                            },{
                              featureType: 'road.local',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#9e9e9e'}]
                            },{
                              featureType: 'transit.line',
                              elementType: 'geometry',
                              stylers: [{color: '#e5e5e5'}]
                            },{
                              featureType: 'transit.station',
                              elementType: 'geometry',
                              stylers: [{color: '#eeeeee'}]
                            },{
                              featureType: 'water',
                              elementType: 'geometry',
                              stylers: [{color: '#c9c9c9'}]
                            },{
                              featureType: 'water',
                              elementType: 'labels.text.fill',
                              stylers: [{color: '#9e9e9e'}]
                            },{
                              featureType: 'poi.attraction',
                              stylers: [{visibility: 'off'},{color: '#54a910'}]
                            },{
                              featureType: 'poi.attraction',
                              elementType: 'labels.text.fill',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            },{
                              featureType: 'poi.business',
                              stylers: [{visibility: 'off'},{color: '#7289d9'}]
                            },{
                              featureType: 'poi.business',
                              elementType: 'labels.text.stroke',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            },{
                              featureType: 'poi.government',
                              stylers: [{visibility: 'off'},{color: '#AF974D'}]
                            },{
                              featureType: 'poi.government',
                              elementType: 'labels.text.stroke',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            },{
                              featureType: 'poi.medical',
                              stylers: [{visibility: 'off'},{color: '#f6412d'}]
                            },{
                              featureType: 'poi.medical',
                              elementType: 'labels.text.stroke',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            },{
                              featureType: 'poi.place_of_worship',
                              stylers: [{visibility: 'off'},{color: '#FFC100'}]
                            },{
                              featureType: 'poi.place_of_worship',
                              elementType: 'labels.text.stroke',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            },{
                              featureType: 'poi.school',
                              stylers: [{visibility: 'off'},{color: '#B391DB'}]
                            },{
                              featureType: 'poi.school',
                              elementType: 'labels.text.stroke',
                              stylers: [{visibility: 'off'},{color: '#ffffff'}]
                            }],
                            lat: 13.756632651221777,
                            lng: 100.56734746141865,
                            data:{
                              province:{},
                              district:{},
                              subdistrict:{},
                              dts:{},
                              minis:{},
                              wms:{},
                              wmops:{},
                              miniops:{},
                              dtops:{}
                            }
                          }
                        }
                      },
                      async mounted() {
                        this.initMap();
                        this.getAPI();
                      },
                      methods: {
                        onChangePOI(){
                          let item=null,value=null,data={},key=null,checkbox={};
                          this.resetLoading(1)
                          for(value of this.options.poi){
                            data['poi.'+value.id]=true;
                          }
                          for(value of this.data.poi){
                            checkbox['poi.'+value.id]=true;
                          }
                          for(item in this.map.styles){
                            key=this.map.styles[item]['featureType'];
                            if(key&&data[key]){
                              if(checkbox[key]){
                                this.map.styles[item]['stylers'][0]['visibility']="on";
                              }else{
                                this.map.styles[item]['stylers'][0]['visibility']="off";
                              }
                            }
                          }
                          this.map.body.setOptions({styles: this.map.styles});
                          this.load.active = false
                        },
                        initMap(){
                          if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(async position => {
                              this.map.lng=position.coords.longitude
                              this.map.lat=position.coords.latitude
                            });
                          }
                          this.map.body = new google.maps.Map(this.$refs['map'],{
                            center: {lat: this.map.lat, lng: this.map.lng},
                            zoom: 12,
                            styles:this.map.styles});
                        },
                        async setMarkerWMs(id,name,gpsdate,barcode,lat,lng,server_date,speed){
                          if(!this.map.data.wms[id]){
                            const marker = new google.maps.Marker({
                              map: this.map.body,
                              position: {lat: parseFloat(lat), lng: parseFloat(lng)},
                              icon: {
                                url: '../../img/icon/wm.png',
                                size:new google.maps.Size(45,45),
                                origin:new google.maps.Point(0,0),
                                anchor:new google.maps.Point(14.0625,45)
                              },
                              title: name,
                              zIndex:1
                            });
                            let infowindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(marker,'click',function(){
                              infowindow.setContent('<div class="text-center"><b><strong>'+name+' , Barcode: '+barcode+'</strong></b><br>เวลาของGPS: '+gpsdate+', เวลาที่ได้รับข้อมูล: '+server_date+', ความเร็วของรถ: '+speed+'</div>');
                              infowindow.open(this.map.body,this);
                            });
                            this.map.data.wms[id]=marker
                          }

                        },
                        setMarkerMinis(id,name,lat,lng,color){
                          if(!this.map.data.minis[id]){
                            const marker = new google.maps.Marker({
                              map: this.map.body,
                              position: {lat: parseFloat(lat), lng: parseFloat(lng)},
                              icon: {
                                url: '../../img/icon/mini.png',
                                size:new google.maps.Size(45,45),
                                origin:new google.maps.Point(0,0),
                                anchor:new google.maps.Point(14.0625,45)
                              },
                              title: name,
                              zIndex:1
                            });
                            let infowindow = new google.maps.InfoWindow();
                            google.maps.event.addListener(marker,'click',function(){
                              infowindow.setContent('<div class="text-center"><strong>มินิ: '+name+'</strong></div>');
                              infowindow.open(this.map.body,this);
                            });
                            this.map.data.minis[id]=marker
                          }
                        },
                        onChangeWMs(){
                          let map={},region=null,dt=null,mini=null,wm=null
                          this.resetLoading(1);
                          for(region of this.data.wms){
                            if(region.children){
                              for(dt of region.children){
                                if(dt.children){
                                  for(mini of dt.children){
                                    if(mini.children){
                                      for(wm of mini.children){
                                        if(wm.lat&&wm.lng){
                                          map[wm.id]=true;
                                          this.setMarkerWMs(wm.id,wm.label,wm.gpsdate,wm.barcode,wm.lat,wm.lng,wm.server_date,wm.speed);
                                        }
                                      }
                                    }else if(mini.lat&&mini.lng){
                                      map[mini.id]=true;
                                      this.setMarkerWMs(mini.id,mini.label,mini.gpsdate,mini.barcode,mini.lat,mini.lng,mini.server_date,mini.speed);
                                    }
                                  }
                                }else if(dt.lat&&dt.lng){
                                  map[dt.id]=true;
                                  this.setMarkerWMs(dt.id,dt.label,dt.gpsdate,dt.barcode,dt.lat,dt.lng,dt.server_date,dt.speed);
                                }
                              }
                            }else if(region.lat&&region.lng){
                              map[region.id]=true;
                              this.setMarkerWMs(region.id,region.label,region.gpsdate,region.barcode,region.lat,region.lng,region.server_date,region.speed);
                            }
                          }
                          for(wm in this.map.data.wms){
                            if(!map[wm]&&this.map.data.wms[wm]){
                              this.map.data.wms[wm].setMap(null);
                              this.map.data.wms[wm]=null;
                            }
                          }
                          this.load.active = false
                        },
                        getArrayDate(start, end){
                          let data = new Array(), date = new Date(start);
                          while (date <= end) {
                            data.push(this.$moment(new Date(date)).format('YYYY-MM-DD'));
                            date.setDate(date.getDate() + 1);
                          }
                          return data;
                        },
                        async geGPSDT(name,id,color,data,arrayDate,frequency,filter){
                          let value=null,api=null,error=null,wm=null,gps=null
                          if(data&&data.length>0){
                            for(value of arrayDate){
                              for(wm of data){
                                if(this.json.wms[wm.id]){
                                  if(this.json.wms[wm.id][value]){
                                    api = wm.gps_member_id
                                  }else{
                                    api=await this.getAPIGPSWM(wm.id,wm.gps_member_id,value)
                                  }
                                }else{
                                  api=await this.getAPIGPSWM(wm.id,wm.gps_member_id,value)
                                }
                                if(api===wm.gps_member_id||api==wm.gps_member_id){
                                  if(this.json.wms[wm.id][value]&&this.json.wms[wm.id][value].length>0){
                                    if(filter.line===true){
                                      await this.setLineMapDT(id,wm.id,wm.label,wm.barcode,color,name,value);
                                    }
                                    if(filter.polygon===true){
                                      await this.setPolygonMapDT(id,wm.id,wm.label,wm.barcode,color,name,value);
                                    }
                                    if(filter.point===true){
                                      await this.setPointMapDT(id,wm.id,wm.fullname,wm.barcode,color,name,value);
                                    }
                                  }
                                }else{
                                  error=api
                                }
                                await this.setPercentLoading()
                              }
                            }
                            if(error!=null){
                              this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล DT Code:'+id});
                            }
                          }
                        },
                        async geGPSMini(name,id,color,data,arrayDate,frequency,filter){
                          let value=null,api=null,error=null,wm=null,gps=null
                          if(data&&data.length>0){
                            for(value of arrayDate){
                              for(wm of data){
                                if(this.json.wms[wm.id]){
                                  if(this.json.wms[wm.id][value]){
                                    api = wm.gps_member_id
                                  }else{
                                    api=await this.getAPIGPSWM(wm.id,wm.gps_member_id,value)
                                  }
                                }else{
                                  api=await this.getAPIGPSWM(wm.id,wm.gps_member_id,value)
                                }
                                if(api===wm.gps_member_id||api==wm.gps_member_id){
                                  if(this.json.wms[wm.id][value]&&this.json.wms[wm.id][value].length>0){
                                    if(filter.line===true){
                                      await this.setLineMapMini(id,wm.id,wm.label,wm.barcode,color,name,value);
                                    }
                                    if(filter.polygon===true){
                                      await this.setPolygonMapMini(id,wm.id,wm.label,wm.barcode,color,name,value);
                                    }
                                    if(filter.point===true){
                                      await this.setPointMapMini(id,wm.id,wm.fullname,wm.barcode,color,name,value);
                                    }
                                  }
                                }else{
                                  error=api
                                }
                                await this.setPercentLoading()
                              }
                            }
                            if(error!=null){
                              this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล Mini Code:'+id});
                            }
                          }
                        },
                        async setPointMapDT(id,wmCode,fullname,barcode,color,name,date){
                          if(!this.map.data.dtops[id]){
                           await this.setDataMapDT(id,color,name);
                         }
                         if(!this.map.data.dtops[id].wms[wmCode]){
                           await this.setDataMapWMofDT(id,wmCode,fullname,barcode);
                         }
                         if(!this.map.data.dtops[id].wms[wmCode].point[date]){
                          this.map.data.dtops[id].wms[wmCode].point[date]=[];
                          let item=null,value=null,gpsdate=null,array={},time=null;
                          for(value of this.json.wms[wmCode][date]){
                            if(this.data.frequency==='minute'){
                              gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
                            }else if(this.data.frequency==='hour'){
                              gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH');
                            }else{
                              gpsdate=value.gpsdate
                            }
                            array[gpsdate]=value
                          }
                          for(item in array){
                            time=(this.$moment(array[item].gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(array[item].gpsdate, 'YYYY-MM-DD').unix())/60;
                            if(time&&time>=0){
                             if(this.data.time.start&&this.data.time.start<=time){
                              if(this.data.time.end){
                                if(this.data.time.end>=time){
                                  await this.setMarkerPointDT(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                                }
                              }else{
                                await this.setMarkerPointDT(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                              }
                            }else{
                              await this.setMarkerPointDT(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                            }
                          } 
                        }
                      }
                    },
                    async setPointMapMini(id,wmCode,fullname,barcode,color,name,date){
                      if(!this.map.data.miniops[id]){
                       await this.setDataMapMini(id,color,name);
                     }
                     if(!this.map.data.miniops[id].wms[wmCode]){
                       await this.setDataMapWMofMini(id,wmCode,fullname,barcode);
                     }
                     if(!this.map.data.miniops[id].wms[wmCode].point[date]){
                      this.map.data.miniops[id].wms[wmCode].point[date]=[];
                      let item=null,value=null,gpsdate=null,array={},time=null;
                      for(value of this.json.wms[wmCode][date]){
                        if(this.data.frequency==='minute'){
                          gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
                        }else if(this.data.frequency==='hour'){
                          gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH');
                        }else{
                          gpsdate=value.gpsdate
                        }
                        array[gpsdate]=value
                      }
                      for(item in array){
                        time=(this.$moment(array[item].gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(array[item].gpsdate, 'YYYY-MM-DD').unix())/60;
                        if(time&&time>=0){
                         if(this.data.time.start&&this.data.time.start<=time){
                          if(this.data.time.end){
                            if(this.data.time.end>=time){
                              await this.setMarkerPointMini(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                            }
                          }else{
                            await this.setMarkerPointMini(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                          }
                        }else{
                          await this.setMarkerPointMini(id,wmCode,fullname,barcode,color,name,date,array[item].lat,array[item].lng,array[item].gpsdate)
                        }
                      } 
                    }
                  }
                },
                setMarkerPointDT(id,wmCode,fullname,barcode,color,name,date,lat,lng,gpsdate){
                  let dataMap = new google.maps.Marker({
                    map: this.map.body,
                    position: {lat: lat, lng: lng},
                    icon: {
                      path: 'M16 3c-7.181 0-13 5.819-13 13s5.819 13 13 13c7.181 0 13-5.819 13-13s-5.819-13-13-13zM16 27.919c-6.569 0-11.919-5.344-11.919-11.919 0-6.569 5.344-11.919 11.919-11.919 6.569 0 11.919 5.344 11.919 11.919 0 6.569-5.35 11.919-11.919 11.919z M16 6c-5.525 0-10 4.475-10 10s4.475 10 10 10c5.525 0 10-4.475 10-10s-4.475-10-10-10z',
                      size:new google.maps.Size(32,32),
                      origin:new google.maps.Point(0,0),
                      anchor:new google.maps.Point(10,32),
                      fillColor: color,
                      fillOpacity: 1,
                      scale: 0.1,
                      strokeColor: color,
                      strokeWeight: 2 
                    },
                    title: 'รหัสศูนย์กระจายสินค้า '+id+': '+name+' (วันที่ '+gpsdate+')',
                    zIndex:1
                  });
                  let infowindow = new google.maps.InfoWindow()
                  google.maps.event.addListener(dataMap,'click',function(){
                    infowindow.setContent('<div class="text-center"><strong>รหัสศูนย์กระจายสินค้า '+id+': ' +name+'<br>'+wmCode+': '+fullname+' Barcode: '+barcode+' | จุดของวันที่: '+gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
                    infowindow.open(this.map.body,this);
                  });
                  this.map.data.dtops[id].wms[wmCode].point[date].push(dataMap)
                },
                setMarkerPointMini(id,wmCode,fullname,barcode,color,name,date,lat,lng,gpsdate){
                  let dataMap = new google.maps.Marker({
                    map: this.map.body,
                    position: {lat: lat, lng: lng},
                    icon: {
                      path: 'M16 3c-7.181 0-13 5.819-13 13s5.819 13 13 13c7.181 0 13-5.819 13-13s-5.819-13-13-13zM16 27.919c-6.569 0-11.919-5.344-11.919-11.919 0-6.569 5.344-11.919 11.919-11.919 6.569 0 11.919 5.344 11.919 11.919 0 6.569-5.35 11.919-11.919 11.919z M16 6c-5.525 0-10 4.475-10 10s4.475 10 10 10c5.525 0 10-4.475 10-10s-4.475-10-10-10z',
                      size:new google.maps.Size(32,32),
                      origin:new google.maps.Point(0,0),
                      anchor:new google.maps.Point(10,32),
                      fillColor: color,
                      fillOpacity: 1,
                      scale: 0.1,
                      strokeColor: color,
                      strokeWeight: 2 
                    },
                    title: 'รหัสมินิ '+id+': '+name+' (วันที่ '+gpsdate+')',
                    zIndex:1
                  });
                  let infowindow = new google.maps.InfoWindow()
                  google.maps.event.addListener(dataMap,'click',function(){
                    infowindow.setContent('<div class="text-center"><strong>รหัสมินิ '+id+': ' +name+'<br>'+wmCode+': '+fullname+' Barcode: '+barcode+' | จุดของวันที่: '+gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
                    infowindow.open(this.map.body,this);
                  });
                  this.map.data.miniops[id].wms[wmCode].point[date].push(dataMap)
                },
                async setLineMapDT(id,wmCode,fullname,barcode,color,name,date){
                  if(!this.map.data.dtops[id]){
                   await this.setDataMapDT(id,color,name);
                 }
                 if(!this.map.data.dtops[id].wms[wmCode]){
                   await this.setDataMapWMofDT(id,wmCode,fullname,barcode);
                 }
                 if(!this.map.data.dtops[id].wms[wmCode].map[date]){
                  const array = await this.setValLatLngWM(wmCode,date);
                  if(array.length>0){
                    let dataMap = new google.maps.Polyline({
                      path: array,
                      geodesic: true,
                      strokeColor: color,
                      strokeOpacity: 1.0,
                      strokeWeight: 1
                    });
                    dataMap.setMap(this.map.body);
                    this.map.data.dtops[id].wms[wmCode].map[date]=dataMap
                  }
                }
              },
              async setLineMapMini(id,wmCode,fullname,barcode,color,name,date){
                if(!this.map.data.miniops[id]){
                 await this.setDataMapMini(id,color,name);
               }
               if(!this.map.data.miniops[id].wms[wmCode]){
                 await this.setDataMapWMofMini(id,wmCode,fullname,barcode);
               }
               if(!this.map.data.miniops[id].wms[wmCode].map[date]){
                const array = await this.setValLatLngWM(wmCode,date);
                if(array.length>0){
                  let dataMap = new google.maps.Polyline({
                    path: array,
                    geodesic: true,
                    strokeColor: color,
                    strokeOpacity: 1.0,
                    strokeWeight: 1
                  });
                  dataMap.setMap(this.map.body);
                  this.map.data.miniops[id].wms[wmCode].map[date]=dataMap
                }
              }
            },
            async geGPSWM(data,arrayDate,frequency,filter){
              let value=null,api=null,error=null
              for(value of arrayDate){
                if(this.json.wms[data.id]){
                  if(this.json.wms[data.id][value]){
                    api = data.gps_member_id
                  }else{
                    api=await this.getAPIGPSWM(data.id,data.gps_member_id,value)
                  }
                }else{
                  api=await this.getAPIGPSWM(data.id,data.gps_member_id,value)
                }
                if(api===data.gps_member_id||api==data.gps_member_id){
                  if(this.json.wms[data.id][value]&&this.json.wms[data.id][value].length>0){
                    if(filter.line===true){
                      await this.setLineMapWM(data,value);
                    }
                    if(filter.polygon===true){
                      await this.setPolygonMapWM(data,value);
                    }
                    if(filter.point===true){
                      await this.setPointMapWM(data,value);
                    }
                  }
                }else{
                  error=api
                }
                await this.setPercentLoading()
              }
              if(error!=null){
                this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล WM Code:'+wmCode});
              }
            },
            setDataMapDT(id,color,name){
              this.map.data.dtops[id]={name:name,color:color,wms:{}};
            },
            setDataMapWMofDT(id,wmCode,fullname,barcode){
              this.map.data.dtops[id].wms[wmCode]={fullname:fullname,barcode:barcode,map:{},poi:{},polygon:{},point:{}};
            },
            setDataMapMini(id,color,name){
              this.map.data.miniops[id]={name:name,color:color,wms:{}};
            },
            setDataMapWMofMini(id,wmCode,fullname,barcode){
              this.map.data.miniops[id].wms[wmCode]={fullname:fullname,barcode:barcode,map:{},poi:{},polygon:{},point:{}};
            },
            setDataMapWM(wmCode,data){
              this.map.data.wmops[wmCode]={fullname:data.fullname,barcode:data.barcode,color_dt:data.color_dt,color_mini:data.color_mini,color_wm:data.color_wm,map:{},poi:{},polygon:{},point:{}};
            },
            distance(lat1, lon1, lat2, lon2) {
              if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
              }else {
                const radlat1 = Math.PI * lat1/180;
                const radlat2 = Math.PI * lat2/180;
                let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos((Math.PI * (lon1-lon2)/180));
                if (dist > 1) {
                  dist = 1;
                }
                return (Math.acos(dist) * 180/Math.PI) * 60 * 1.1515;
              }
            },
            setMarkerPoint(wmCode,date,lat,lng,data,gpsdate){
              let dataMap = new google.maps.Marker({
                map: this.map.body,
                position: {lat: lat, lng: lng},
                icon: {
                  path: 'M16 3c-7.181 0-13 5.819-13 13s5.819 13 13 13c7.181 0 13-5.819 13-13s-5.819-13-13-13zM16 27.919c-6.569 0-11.919-5.344-11.919-11.919 0-6.569 5.344-11.919 11.919-11.919 6.569 0 11.919 5.344 11.919 11.919 0 6.569-5.35 11.919-11.919 11.919z M16 6c-5.525 0-10 4.475-10 10s4.475 10 10 10c5.525 0 10-4.475 10-10s-4.475-10-10-10z',
                  size:new google.maps.Size(32,32),
                  origin:new google.maps.Point(0,0),
                  anchor:new google.maps.Point(10,32),
                  fillColor: data.color_wm,
                  fillOpacity: 1,
                  scale: 0.1,
                  strokeColor: data.color_wm,
                  strokeWeight: 2 
                },
                title: wmCode+': '+data.fullname+' | Barcode: '+data.barcode+' (วันที่ '+gpsdate+')',
                zIndex:1
              });
              let infowindow = new google.maps.InfoWindow()
              google.maps.event.addListener(dataMap,'click',function(){
                infowindow.setContent('<div class="text-center"><strong>'+wmCode+': '+data.fullname+'<br>Barcode: '+data.barcode+' | จุดของวันที่: '+gpsdate+'<div style="background-color:'+data.color_wm+';width:100%;height:1em;"></div></strong></div>');
                infowindow.open(this.map.body,this);
              });
              this.map.data.wmops[wmCode].point[date].push(dataMap)
            },
            async setPointMapWM(data,date){
              let wmCode = data.id
              if(!this.map.data.wmops[wmCode]){
                await this.setDataMapWM(wmCode,data);
              }
              if(!this.map.data.wmops[wmCode].point[date]){
                this.map.data.wmops[wmCode].point[date]=[];
                let item=null,value=null,gpsdate=null,array={},time=null;
                for(value of this.json.wms[wmCode][date]){
                  if(this.data.frequency==='minute'){
                    gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm');
                  }else if(this.data.frequency==='hour'){
                    gpsdate=this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH');
                  }else{
                    gpsdate=value.gpsdate
                  }
                  array[gpsdate]=value
                }
                for(item in array){
                  time=(this.$moment(array[item].gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(array[item].gpsdate, 'YYYY-MM-DD').unix())/60;
                  if(time&&time>=0){
                   if(this.data.time.start&&this.data.time.start<=time){
                    if(this.data.time.end){
                      if(this.data.time.end>=time){
                        await this.setMarkerPoint(wmCode,date,array[item].lat,array[item].lng,data,array[item].gpsdate)
                      }
                    }else{
                      await this.setMarkerPoint(wmCode,date,array[item].lat,array[item].lng,data,array[item].gpsdate)
                    }
                  }else{
                    await this.setMarkerPoint(wmCode,date,array[item].lat,array[item].lng,data,array[item].gpsdate)
                  }
                } 
              }
            }
          },
          setValLatLngWM(wmCode,date){
            let value=null,time=null,data=[]
            for(value of this.json.wms[wmCode][date]){
              time=(this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(value.gpsdate, 'YYYY-MM-DD').unix())/60;
              if(time&&time>=0){
               if(this.data.time.start&&this.data.time.start<=time){
                if(this.data.time.end){
                  if(this.data.time.end>=time){
                    data.push({lat:value.lat,lng:value.lng})
                  }
                }else{
                  data.push({lat:value.lat,lng:value.lng})
                }
              }else{
                data.push({lat:value.lat,lng:value.lng})
              }
            } 
          }
          return data;
        },
        async setPolygonMapDT(id,wmCode,fullname,barcode,color,name,date){
          if(!this.map.data.dtops[id]){
           await this.setDataMapDT(id,color,name);
         }
         if(!this.map.data.dtops[id].wms[wmCode]){
           await this.setDataMapWMofDT(id,wmCode,fullname,barcode);
         }
         if(!this.map.data.dtops[id].wms[wmCode].polygon[date]){
          const array = await this.setValLatLngWM(wmCode,date);
          if(array.length>0){
            let dataMap = new google.maps.Polygon({
              paths: array,
              strokeColor: color,
              strokeOpacity: 0.5,
              strokeWeight: 1,
              fillColor: color,
              fillOpacity: 0.35
            });
            dataMap.setMap(this.map.body);
            this.map.data.dtops[id].wms[wmCode].polygon[date]=dataMap
          }
        }
      },
      async setPolygonMapMini(id,wmCode,fullname,barcode,color,name,date){
        if(!this.map.data.miniops[id]){
         await this.setDataMapMini(id,color,name);
       }
       if(!this.map.data.miniops[id].wms[wmCode]){
         await this.setDataMapWMofMini(id,wmCode,fullname,barcode);
       }
       if(!this.map.data.miniops[id].wms[wmCode].polygon[date]){
        const array = await this.setValLatLngWM(wmCode,date);
        if(array.length>0){
          let dataMap = new google.maps.Polygon({
            paths: array,
            strokeColor: color,
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: color,
            fillOpacity: 0.35
          });
          dataMap.setMap(this.map.body);
          this.map.data.miniops[id].wms[wmCode].polygon[date]=dataMap
        }
      }
    },
    async setPolygonMapWM(data,date){
      let wmCode = data.id
      if(!this.map.data.wmops[wmCode]){
        await this.setDataMapWM(wmCode,data);
      }
      if(!this.map.data.wmops[wmCode].polygon[date]){
        const array = this.setValLatLngWM(wmCode,date);
        if(array.length>0){
          let dataMap = new google.maps.Polygon({
            paths: array,
            strokeColor: data.color_wm,
            strokeOpacity: 0.5,
            strokeWeight: 1,
            fillColor: data.color_wm,
            fillOpacity: 0.35
          });
          dataMap.setMap(this.map.body);
          this.map.data.wmops[wmCode].polygon[date]=dataMap
        }
      }
    },
    async setLineMapWM(data,date){
      let wmCode = data.id
      if(!this.map.data.wmops[wmCode]){
       await this.setDataMapWM(wmCode,data);
     }
     if(!this.map.data.wmops[wmCode].map[date]){
      const array = await this.setValLatLngWM(wmCode,date);
      if(array.length>0){
        let dataMap = new google.maps.Polyline({
          path: array,
          geodesic: true,
          strokeColor: data.color_wm,
          strokeOpacity: 1.0,
          strokeWeight: 1
        });
        dataMap.setMap(this.map.body);
        this.map.data.wmops[wmCode].map[date]=dataMap
      }
    }
  },
  clearSearch(){
    let wmCode=null,date=null,item=null,miniCode=null,dtCode=null;
    for(wmCode in this.map.data.wmops){
      for(date in this.map.data.wmops[wmCode].map){
        if(this.map.data.wmops[wmCode].map[date]){
          this.map.data.wmops[wmCode].map[date].setMap(null);
          this.map.data.wmops[wmCode].map[date]=null;
        }
      }
      for(date in this.map.data.wmops[wmCode].polygon){
        if(this.map.data.wmops[wmCode].polygon[date]){
          this.map.data.wmops[wmCode].polygon[date].setMap(null);
          this.map.data.wmops[wmCode].polygon[date]=null;
        }
      }
      for(date in this.map.data.wmops[wmCode].point){
        for(item in this.map.data.wmops[wmCode].point[date]){
          if(this.map.data.wmops[wmCode].point[date][item]){
            this.map.data.wmops[wmCode].point[date][item].setMap(null);
          }
        }
        this.map.data.wmops[wmCode].point[date]=null;
      }
      for(date in this.map.data.wmops[wmCode].poi){
        if(this.map.data.wmops[wmCode].poi[date]){
          if(this.map.data.wmops[wmCode].poi[date].start){
            this.map.data.wmops[wmCode].poi[date].start.setMap(null);
          }
          if(this.map.data.wmops[wmCode].poi[date].end){
            this.map.data.wmops[wmCode].poi[date].end.setMap(null);
          }
          this.map.data.wmops[wmCode].poi[date]=null;
        }
      }
    }
    for(miniCode in this.map.data.miniops){
      for(wmCode in this.map.data.miniops[miniCode].wms){
        for(date in this.map.data.miniops[miniCode].wms[wmCode].map){
          if(this.map.data.miniops[miniCode].wms[wmCode].map[date]){
            this.map.data.miniops[miniCode].wms[wmCode].map[date].setMap(null);
            this.map.data.miniops[miniCode].wms[wmCode].map[date]=null;
          }
        }
        for(date in this.map.data.miniops[miniCode].wms[wmCode].polygon){
          if(this.map.data.miniops[miniCode].wms[wmCode].polygon[date]){
            this.map.data.miniops[miniCode].wms[wmCode].polygon[date].setMap(null);
            this.map.data.miniops[miniCode].wms[wmCode].polygon[date]=null;
          }
        }
        for(date in this.map.data.miniops[miniCode].wms[wmCode].point){
          for(item in this.map.data.miniops[miniCode].wms[wmCode].point[date]){
            if(this.map.data.miniops[miniCode].wms[wmCode].point[date][item]){
              this.map.data.miniops[miniCode].wms[wmCode].point[date][item].setMap(null);
            }
          }
          this.map.data.miniops[miniCode].wms[wmCode].point[date]=null;
        }
        for(date in this.map.data.miniops[miniCode].wms[wmCode].poi){
          if(this.map.data.miniops[miniCode].wms[wmCode].poi[date]){
            if(this.map.data.miniops[miniCode].wms[wmCode].poi[date].start){
              this.map.data.miniops[miniCode].wms[wmCode].poi[date].start.setMap(null);
            }
            if(this.map.data.miniops[miniCode].wms[wmCode].poi[date].end){
              this.map.data.miniops[miniCode].wms[wmCode].poi[date].end.setMap(null);
            }
            this.map.data.miniops[miniCode].wms[wmCode].poi[date]=null;
          }
        }
      }
    }
    for(dtCode in this.map.data.dtops){
      for(wmCode in this.map.data.dtops[dtCode].wms){
        for(date in this.map.data.dtops[dtCode].wms[wmCode].map){
          if(this.map.data.dtops[dtCode].wms[wmCode].map[date]){
            this.map.data.dtops[dtCode].wms[wmCode].map[date].setMap(null);
            this.map.data.dtops[dtCode].wms[wmCode].map[date]=null;
          }
        }
        for(date in this.map.data.dtops[dtCode].wms[wmCode].polygon){
          if(this.map.data.dtops[dtCode].wms[wmCode].polygon[date]){
            this.map.data.dtops[dtCode].wms[wmCode].polygon[date].setMap(null);
            this.map.data.dtops[dtCode].wms[wmCode].polygon[date]=null;
          }
        }
        for(date in this.map.data.dtops[dtCode].wms[wmCode].point){
          for(item in this.map.data.dtops[dtCode].wms[wmCode].point[date]){
            if(this.map.data.dtops[dtCode].wms[wmCode].point[date][item]){
              this.map.data.dtops[dtCode].wms[wmCode].point[date][item].setMap(null);
            }
          }
          this.map.data.dtops[dtCode].wms[wmCode].point[date]=null;
        }
        for(date in this.map.data.dtops[dtCode].wms[wmCode].poi){
          if(this.map.data.dtops[dtCode].wms[wmCode].poi[date]){
            if(this.map.data.dtops[dtCode].wms[wmCode].poi[date].start){
              this.map.data.dtops[dtCode].wms[wmCode].poi[date].start.setMap(null);
            }
            if(this.map.data.dtops[dtCode].wms[wmCode].poi[date].end){
              this.map.data.dtops[dtCode].wms[wmCode].poi[date].end.setMap(null);
            }
            this.map.data.dtops[dtCode].wms[wmCode].poi[date]=null;
          }
        }
      }
    }
  },
  async getAPIGPSWM(wmCode,memberID,date){
    try {
      let value=null,data=[]
      const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/maps/drawmap/gps/'+memberID+'/'+date)).body
      if(!this.json.wms[wmCode]){
        this.json.wms[wmCode]={};
      }
      for(value of res['data']){
        data.push({lat: parseFloat(value.lat),lng: parseFloat(value.lng),gpsdate: value.gpsdate})
      }
      this.json.wms[wmCode][date]=data
      return res['id']
    } catch (error) {
      if (error.body) {
        if (error.body.alert) {
          return error.body.alert+' (WM Code: '+wmCode+' , Date: '+date+')'
        } else {
          return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
      } else {
        return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
    }
  },
  loadCountAPIWM(countDate){
    let region=null,dt=null,mini=null,wm=null,count=0
    for(region of this.data.filter.wms){
      if(region.children){
        for(dt of region.children){
          if(dt.children){
            for(mini of dt.children){
              if(mini.children){
                for(wm of mini.children){
                  count=count+countDate
                }
              }else{
                count=count+countDate
              }
            }
          }else{
            count=count+countDate
          }
        }
      }else{
        count=count+countDate
      }
    }
    return count
  },
  loadCountAPIDT(countDate){
    let region=null,dt=null,count=0
    for(region of this.data.filter.dts){
      if(region.children){
        for(dt of region.children){
          count=count+(countDate*dt.wms.length)
        }
      }else{
        count=count+(countDate*region.wms.length)
      }
    }
    return count
  },
  loadCountAPIMINI(countDate){
    let region=null,dt=null,mini=null,count=0
    for(region of this.data.filter.minis){
      if(region.children){
        for(dt of region.children){
          if(dt.children){
            for(mini of dt.children){
              count=count+(countDate*mini.wms.length)
            }
          }else{
            count=count+(countDate*dt.wms.length)
          }
        }
      }else{
        count=count+(countDate*region.wms.length)
      }
    }
    return count
  },
  checkFilter(option){
    let key =null, data={line:false,polygon:false,point:false}
    for(key of this.data.filter.options[option]){
      data[key]=true;
    }
    return data
  },
  async getMinis(array,filter){
    try {
     let region=null,dt=null,mini=null
     for(region of this.data.filter.minis){
      if(region.children){
        for(dt of region.children){
          if(dt.children){
            for(mini of dt.children){
              await this.geGPSMini(mini.label,mini.id,mini.color,mini.wms,array.date,array.frequency,filter)
            }
          }else{
            await this.geGPSMini(dt.label,dt.id,dt.color,dt.wms,array.date,array.frequency,filter)
          }
        }
      }else{
        await this.geGPSMini(region.label,region.id,region.color,region.wms,array.date,array.frequency,filter)
      }
    }
    if(filter.line===true){
      await this.poiLineMap('mini');
    }
  } catch (error) {
    this.$dialogs.alert('กรุณาเลือกช่วงเวลาของมินิที่ต้องการค้นหาและข้อมูลที่ต้องการทราบ',{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'})
  }
},
async getDTs(array,filter){
  try {
   let region=null,dt=null,mini=null
   for(region of this.data.filter.dts){
    if(region.children){
      for(dt of region.children){
        await this.geGPSDT(dt.label,dt.id,dt.color,dt.wms,array.date,array.frequency,filter)
      }
    }else{
      await this.geGPSDT(region.label,region.id,region.color,region.wms,array.date,array.frequency,filter)
    }
  }
  if(filter.line===true){
    await this.poiLineMap('dt');
  }
} catch (error) {
  this.$dialogs.alert('กรุณาเลือกช่วงเวลาของศูนย์จัดจำหน่ายที่ต้องการค้นหาและข้อมูลที่ต้องการทราบ',{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'})
}
},
async getWMs(array,filter){
  try {
   let region=null,dt=null,mini=null,wm=null
   for(region of this.data.filter.wms){
    if(region.children){
      for(dt of region.children){
        if(dt.children){
          for(mini of dt.children){
            if(mini.children){
              for(wm of mini.children){
                await this.geGPSWM(wm,array.date,array.frequency,filter)
              }
            }else{
              await this.geGPSWM(mini,array.date,array.frequency,filter)
            }
          }
        }else{
          await this.geGPSWM(dt,array.date,array.frequency,filter)
        }
      }
    }else{
      await this.geGPSWM(region,array.date,array.frequency,filter)
    }
  }
  if(filter.line===true){
    await this.poiLineMap('wm');
  }
} catch (error) {
  this.$dialogs.alert('กรุณาเลือกช่วงเวลาของวอลล์แมน/เลดี้ที่ต้องการค้นหาและข้อมูลที่ต้องการทราบ',{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'})
}
},
async searchAPI(filter,active){
  let array={date: await this.getArrayDate(this.picker.start,this.picker.end),frequency:'hour'},count=0;
  if(this.data.frequency){
    array.frequency=this.data.frequency;
  }
  if(active.wm){
    count=count+this.loadCountAPIWM(array.date.length);
  }
  if(active.mini){
    count=count+this.loadCountAPIMINI(array.date.length);
  }
  if(active.dt){
    count=count+this.loadCountAPIDT(array.date.length);
  }
  this.resetLoading(count);
  if(active.wm===true){
    await this.getWMs(array,filter.wm);
  }
  if(active.mini===true){
    await this.getMinis(array,filter.mini);
  }
  if(active.dt===true){
    await this.getDTs(array,filter.dt);
  }
  this.load.active = false
},
async onChangeSearch(){
  let filter={wm: await this.checkFilter('wms'),mini: await this.checkFilter('minis'),dt: await this.checkFilter('dts')},active={wm:false,mini:false,dt:false}
  await this.clearSearch()
  if((filter.wm.line||filter.wm.polygon||filter.wm.point)){
    if(this.data.filter.wms.length<=0){
     this.$dialogs.alert('กรุณาเลือกวอลล์แมน/เลดี้ที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูล'})
   }else if(filter.wm.point&&!this.data.frequency){
     this.$dialogs.alert('เมื่อเลือกการกรอง "จุดตามเวลา" ต้องเลือกช่วงเวลาความถี่ด้วย',{title: 'กรุณาเลือกข้อมูล'})
   }else{
    active.wm=true;
  }
}else if(this.data.filter.wms.length>0){
  this.$dialogs.alert('กรุณาเลือกการกรองวอลล์แมน/เลดี้ที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูลการกรอง'})
}else if((filter.mini.line||filter.mini.polygon||filter.mini.point)){
  if(this.data.filter.minis.length<=0){
   this.$dialogs.alert('กรุณาเลือกมินิที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูล'})
 }else if(filter.mini.point&&!this.data.frequency){
   this.$dialogs.alert('เมื่อเลือกการกรอง "จุดตามเวลา" ต้องเลือกช่วงเวลาความถี่ด้วย',{title: 'กรุณาเลือกข้อมูล'})
 }else{
  active.mini=true;
}
}else if(this.data.filter.minis.length>0){
  this.$dialogs.alert('กรุณาเลือกการกรองมินิที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูลการกรอง'})
}else if((filter.dt.line||filter.dt.polygon||filter.dt.point)){
  if(this.data.filter.dts.length<=0){
   this.$dialogs.alert('กรุณาเลือกศูนย์จัดจำหน่ายที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูล'})
 }else if(filter.dt.point&&!this.data.frequency){
   this.$dialogs.alert('เมื่อเลือกการกรอง "จุดตามเวลา" ต้องเลือกช่วงเวลาความถี่ด้วย',{title: 'กรุณาเลือกข้อมูล'})
 }else{
  active.dt=true;
}
}else if(this.data.filter.dts.length>0){
  this.$dialogs.alert('กรุณาเลือกการกรองศูนย์จัดจำหน่ายที่ต้องการค้นหา',{title: 'กรุณาเลือกข้อมูลการกรอง'})
}
if(active.wm===true||active.mini===true||active.dt===true){
  await this.searchAPI(filter,active);
}
},
setPOILineMap(value,key,color,name,code,barcode,date,fullname='',wmCode=''){
  let poi={start:null,end:null}
  poi.start = new google.maps.Marker({
    map: this.map.body,
    animation: google.maps.Animation.DROP,
    position: {lat: value.start.lat, lng: value.start.lng},
    icon: {
      path: this.svg[key].start,
      size:new google.maps.Size(20,20),
      origin:new google.maps.Point(0,0),
      anchor:new google.maps.Point(6.25,20),
      fillColor: color,
      fillOpacity: 1,
      scale: 0.8,
      strokeColor: '#ffffff',
      strokeWeight: 1 
    },
    title: key+' '+code+': '+name+' (เริ่มต้นของวันที่ '+value.end.gpsdate+')',
    zIndex:1
  });
  poi.end = new google.maps.Marker({
    map: this.map.body,
    animation: google.maps.Animation.DROP,
    position: {lat: value.end.lat, lng: value.end.lng},
    icon: {
      path: this.svg[key].end,
      size:new google.maps.Size(20,20),
      origin:new google.maps.Point(0,0),
      anchor:new google.maps.Point(6.25,20),
      fillColor: color,
      fillOpacity: 1,
      scale: 0.8,
      strokeColor: '#ffffff',
      strokeWeight: 1 
    },
    title: key+' '+code+': '+name+' (สิ้นสุดของวันที่ '+value.end.gpsdate+')',
    zIndex:1
  });
  let infowindow = new google.maps.InfoWindow();
  if(key==='wm'){
    google.maps.event.addListener(poi.start,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+code+': '+name+'<br>Barcode: '+barcode+' | เริ่มต้นของวันที่: '+value.start.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    google.maps.event.addListener(poi.end,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+code+': '+name+'<br>Barcode: '+barcode+' | สิ้นสุดของวันที่: '+value.end.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    this.map.data.wmops[code].poi[date]=poi
  }else if(key==='mini'){
    google.maps.event.addListener(poi.start,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+'มินิ '+code+': '+name+'<br>โดย '+fullname+' Barcode: '+barcode+' | เริ่มต้นของวันที่: '+value.start.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    google.maps.event.addListener(poi.end,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+'มินิ '+code+': '+name+'<br>โดย '+fullname+' Barcode: '+barcode+' | สิ้นสุดของวันที่: '+value.end.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    this.map.data.miniops[code].wms[wmCode].poi[date]=poi
  }else if(key==='dt'){
    google.maps.event.addListener(poi.start,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+'ศูนย์จัดจำหน่าย '+code+': '+name+'<br>โดย '+fullname+' Barcode: '+barcode+' | เริ่มต้นของวันที่: '+value.start.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    google.maps.event.addListener(poi.end,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>'+'ศูนย์จัดจำหน่าย '+code+': '+name+'<br>โดย '+fullname+' Barcode: '+barcode+' | สิ้นสุดของวันที่: '+value.end.gpsdate+'<div style="background-color:'+color+';width:100%;height:1em;"></div></strong></div>');
      infowindow.open(this.map.body,this);
    });
    this.map.data.dtops[code].wms[wmCode].poi[date]=poi
  }
},
setValPOILineMap(time,value){
  time.total = new Date(value.gpsdate)
  if(time.start&&time.start.time<=time.total){
    time.start={lat:value.lat,lng:value.lng,gpsdate:value.gpsdate,time:time.total}
  }else if(!time.start){
    time.start={lat:value.lat,lng:value.lng,gpsdate:value.gpsdate,time:time.total}
  }
  if(time.end&&time.end.time>=time.total){
    time.end={lat:value.lat,lng:value.lng,gpsdate:value.gpsdate,time:time.total}
  }else if(!time.end){
    time.end={lat:value.lat,lng:value.lng,gpsdate:value.gpsdate,time:time.total}
  }
  return time
},
async poiLineMap(key){
  let value=null,date=null,wmCode=null,time={start:null,end:null,total:null},timeDate=null,miniCode=null,dtCode=null;
  if(key==='wm'){
    for(wmCode in this.map.data.wmops){
      for(date in this.map.data.wmops[wmCode].map){
        if(this.map.data.wmops[wmCode].map[date]&&this.json.wms[wmCode][date]){
          time={start:null,end:null,total:null}
          for(value of this.json.wms[wmCode][date]){
            timeDate=(this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(value.gpsdate, 'YYYY-MM-DD').unix())/60;
            if(timeDate&&timeDate>=0){
             if(this.data.time.start&&this.data.time.start<=timeDate){
              if(this.data.time.end){
                if(this.data.time.end>=timeDate){
                  time=this.setValPOILineMap(time,value)
                }
              }else{
                time=this.setValPOILineMap(time,value)
              }
            }else{
              time=this.setValPOILineMap(time,value)
            }
          }
        }
        await this.setPOILineMap(time,key,this.map.data.wmops[wmCode].color_wm,this.map.data.wmops[wmCode].fullname,wmCode,this.map.data.wmops[wmCode].barcode,date)
      }
    }
  }
}else if(key==='mini'){
  for(miniCode in this.map.data.miniops){
    for(wmCode in this.map.data.miniops[miniCode].wms){
      for(date in this.map.data.miniops[miniCode].wms[wmCode].map){
        if(this.map.data.miniops[miniCode].wms[wmCode].map[date]&&this.json.wms[wmCode][date]){
          time={start:null,end:null,total:null}
          for(value of this.json.wms[wmCode][date]){
            timeDate=(this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(value.gpsdate, 'YYYY-MM-DD').unix())/60;
            if(timeDate&&timeDate>=0){
             if(this.data.time.start&&this.data.time.start<=timeDate){
              if(this.data.time.end){
                if(this.data.time.end>=timeDate){
                  time=this.setValPOILineMap(time,value)
                }
              }else{
                time=this.setValPOILineMap(time,value)
              }
            }else{
              time=this.setValPOILineMap(time,value)
            }
          }
        }
        await this.setPOILineMap(time,key,this.map.data.miniops[miniCode].color,this.map.data.miniops[miniCode].name,miniCode,this.map.data.miniops[miniCode].wms[wmCode].barcode,date,this.map.data.miniops[miniCode].wms[wmCode].fullname,wmCode)
      }
    }
  }
}
}else if(key==='dt'){
  for(dtCode in this.map.data.dtops){
    for(wmCode in this.map.data.dtops[dtCode].wms){
      for(date in this.map.data.dtops[dtCode].wms[wmCode].map){
        if(this.map.data.dtops[dtCode].wms[wmCode].map[date]&&this.json.wms[wmCode][date]){
          time={start:null,end:null,total:null}
          for(value of this.json.wms[wmCode][date]){
            timeDate=(this.$moment(value.gpsdate, 'YYYY-MM-DD HH:mm:ss').unix()-this.$moment(value.gpsdate, 'YYYY-MM-DD').unix())/60;
            if(timeDate&&timeDate>=0){
             if(this.data.time.start&&this.data.time.start<=timeDate){
              if(this.data.time.end){
                if(this.data.time.end>=timeDate){
                  time=this.setValPOILineMap(time,value)
                }
              }else{
                time=this.setValPOILineMap(time,value)
              }
            }else{
              time=this.setValPOILineMap(time,value)
            }
          }
        }
        await this.setPOILineMap(time,key,this.map.data.dtops[dtCode].color,this.map.data.dtops[dtCode].name,dtCode,this.map.data.dtops[dtCode].wms[wmCode].barcode,date,this.map.data.dtops[dtCode].wms[wmCode].fullname,wmCode)
      }
    }
  }
}
}
},
onChangeMinis(){
  let value2=null,mini=null,value=null,map={};
  this.resetLoading(1);
  for(mini of this.data.minis){
    if(mini.children){
      for(value of mini.children){
        if(value.children){
          for(value2 of value.children){
            map[value2.id]=true;
            this.setMarkerMinis(value2.id,value2.label,value2.lat,value2.lng,value2.color);
          }
        }else{
          map[value.id]=true;
          this.setMarkerMinis(value.id,value.label,value.lat,value.lng,value.color);
        }
      }
    }else{
      map[mini.id]=true;
      this.setMarkerMinis(mini.id,mini.label,mini.lat,mini.lng,mini.color);
    }
  }
  for(mini in this.map.data.minis){
    if(!map[mini]&&this.map.data.minis[mini]){
      this.map.data.minis[mini].setMap(null);
      this.map.data.minis[mini]=null;
    }
  }
  this.load.active = false
},
setMarkerDTs(id,name,lat,lng,color){
  if(!this.map.data.dts[id]){
    const marker = new google.maps.Marker({
      map: this.map.body,
      position: {lat: parseFloat(lat), lng: parseFloat(lng)},
      icon: {
        url: '../../img/icon/dt.png',
        size:new google.maps.Size(55,55),
        origin:new google.maps.Point(0,0),
        anchor:new google.maps.Point(17.1875,55)
      },
      title: name,
      zIndex:1
    });
    let infowindow = new google.maps.InfoWindow();
    google.maps.event.addListener(marker,'click',function(){
      infowindow.setContent('<div class="text-center"><strong>ศูนย์จัดจำหน่าย: '+name+'</strong></div>');
      infowindow.open(this.map.body,this);
    });
    this.map.data.dts[id]=marker
  }
},
onChangeTimeStart(){
  let value=null,data=[]
  if(this.data.time.start){
    for(value of this.options.time.start){
      if(value.id>this.data.time.start){
        data.push(value)
      }
    }
    data.push({id:1440,label:'24:00'})
    if(this.data.time.start>=this.data.time.end){
      this.data.time.end=null;
    }
  }else{
    this.data.time.end=null;
  }
  this.options.time.end=data
},
onChangeDTs(){
  let dt=null,value=null,map={};
  this.resetLoading(1);
  for(dt of this.data.dts){
    if(dt.children){
      for(value of dt.children){
        map[value.id]=true;
        this.setMarkerDTs(value.id,value.label,value.lat,value.lng,value.color);
      }
    }else{
      map[dt.id]=true;
      this.setMarkerDTs(dt.id,dt.label,dt.lat,dt.lng,dt.color);
    }
  }
  for(dt in this.map.data.dts){
    if(!map[dt]&&this.map.data.dts[dt]){
      this.map.data.dts[dt].setMap(null);
      this.map.data.dts[dt]=null;
    }
  }
  this.load.active = false
},
checkSubdistrict(){
  let value=null, value2=null,subdistrict=null,data={};
  for(subdistrict of this.data.district){
    if(subdistrict.children){
      for(value2 of subdistrict.children){
        if(value2.children){
          for(value of value2.children){
            data[value.id]=true;
          }
        }else{
          data[value2.id]=true;
        }
      }
    }else{
      data[subdistrict.id]=true;
    }
  }
  return data;
},
async onChangeDistrict(){
  let key=null,value=null;
  this.resetLoading(1);
  const data = this.checkSubdistrict()
  for(key in data){
    if(!this.map.data.subdistrict[key]&&this.json.subdistrict[key].maps){
      this.map.data.subdistrict[key]=[]
      for(value of this.json.subdistrict[key].maps){
        if(value.length>0){
          this.map.data.subdistrict[key].push(await this.setPolygon(value,'#77685D',0.5,0.5));
        }
      }
    }
  }
  await this.removePolygon(data,'subdistrict');
  this.load.active = false
},
removePolygon(data,key){
  let id=null,value=null,subdistrict=null,value2=null,dataSet1=[],dataSet2=[],dataSet3=[];
  for(id in this.map.data[key]){
    if(!data[id]&&this.map.data[key][id]){
      for(value of this.map.data[key][id]){
        if(value){
          value.setMap(null);
        }
      }
      this.map.data[key][id]=null;
    }
  }
  if(key==='subdistrict'){
    for(subdistrict of this.data.district){
      if(subdistrict.children){
        dataSet2=[]
        for(value2 of subdistrict.children){
          if(value2.children){
            dataSet3=[]
            for(value of value2.children){
              if(data[value.id]){
                dataSet3.push(value)
              }
            }
            if(dataSet3.length>0){
              dataSet2.push({id:value2.id,label:value2.label,children:dataSet3})
            }
          }else if(data[value2.id]){
            dataSet2.push(value2)
          }
        }
        if(dataSet2.length>0){
          dataSet1.push({id:subdistrict.id,label:subdistrict.label,children:dataSet2})
        }
      }else if(data[id]){
        dataSet1.push(subdistrict)
      }
    }
    this.data.district=dataSet1
  }else if(key==='district'){
    for(value2 of this.data.province){
      if(value2.children){
        dataSet2=[]
        for(value of value2.children){
          if(data[value.id]){
            dataSet2.push(value)
          }
        }
        if(dataSet2.length>0){
          dataSet1.push({id:value2.id,label:value2.label,children:dataSet2})
        }
      }else if(data[value2.id]){
        dataSet1.push(value2)
      }
    }
    this.data.province=dataSet1
  }
},
async onChangeProvince(){
  let subvalue=null,valSet=null,data = [],province=null,district=null,subdistrict=null
  const array = await this.setSubdistrict();
  for(province in array){
    valSet={
      id: 'province'+province,
      label: array[province].label,
      children: []
    }
    for(district in array[province].children){
      subvalue={
        id: 'district'+district,
        label: array[province].children[district].label,
        children: []
      }
      for(subdistrict in array[province].children[district].children){
        subvalue.children.push({id:subdistrict,label:array[province].children[district].children[subdistrict].label})
      }
      valSet.children.push(subvalue)
    }
    data.push(valSet)
  }
  this.options.district=data
  this.placeholder.district = (this.options.district.length > 0 ? 'เลือกเขต/ตำบล...':'กรุณาเลือกแขวง/อำเภอ...')
},
async setSubdistrict(){
  this.resetLoading(await this.loadSubdistrict(),'โหลดแขวง...');
  let item=null,district=null,value=null,error=null,data=[], api={},map={district:{},subdistrict:{}};
  for(district of this.data.province){
    if(district.children){
      for(value of district.children){
        map.district[value.id]=true;
        api = await this.setDistrictChildren(value.id,data,error);
        data=api['data'];
        error=api['error'];
      }
    }else{
      map.district[district.id]=true;
      api = await this.setDistrictChildren(district.id,data,error);
      data=api['data'];
      error=api['error'];
    }
  }
  for(item in map.district){
    if(this.json.district[item]&&this.json.district[item].list){
      for(value of this.json.district[item].list){
        map.subdistrict[value]=true
      }
    }
  }
  await this.removePolygon(map.district,'district');
  await this.removePolygon(map.subdistrict,'subdistrict');
  this.load.active = false
  if(error!=null){
    this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'});
  }
  return data;
},
async setDistrictChildren(id,data,error){
  let value=null,api = null , key = null, province_id=null,district_id=null
  if(this.json.district[id]){
    if(this.json.district[id].list){
      for(key of this.json.district[id].list){
        if(!this.json.subdistrict[key]){
          api = await this.getSubdistrict(key)
        }else{
          api = key
        }
        if(api===key||api==key){
          district_id=this.json.subdistrict[key].district_id;
          province_id=this.json.subdistrict[key].province_id;
          if(!data[province_id]){
            data[province_id]={
              id: province_id,
              label: this.json.province[province_id].name,
              children: {}
            }
          }
          if(!data[province_id].children[district_id]){
            data[province_id].children[district_id]={
              id: district_id,
              label: this.json.district[district_id].name,
              children: {}
            }
          }
          data[province_id].children[district_id].children[key]={
            id: key,
            label: this.json.subdistrict[key].name
          }
        }else{
          error=api
        }
        await this.setPercentLoading()
      }
    }
    if(!this.map.data.district[id]&&this.json.district[id].maps){
      this.map.data.district[id]=[]
      for(value of this.json.district[id].maps){
        if(value.length>0){
          this.map.data.district[id].push(await this.setPolygon(value,'#A39A92',1,0.5));
        }
      }
    }
  }
  return {data:data,error:error};
},
async getSubdistrict(id){
  try {
    const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/maps/drawmap/subdistrict/'+id)).body
    this.json.subdistrict[res['id']]={
      province_id: res['data']['changwat_id'],
      district_id: res['data']['amphoe_id'],
      name: res['data']['name_th']+' ('+res['data']['zip_code']+')',
      maps: res['data']['map']
    }
    return res['id']
  } catch (error) {
    if (error.body) {
      if (error.body.alert) {
        return error.body.alert+' (Subdistrict: '+id+')'
      } else {
        return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
    } else {
      return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
    }
  }
},
loadSubdistrict(){
  let key=null, value=null, count=0
  for(value of this.data.province){
    if(value.children){
      for(key of value.children){
        if(this.json.district[key.id]&&this.json.district[key.id].list){
          count=count+this.json.district[key.id].list.length
        }
      }
    }else{
      if(this.json.district[value.id]&&this.json.district[value.id].list){
        count=count+this.json.district[value.id].list.length
      }
    }
  }
  return count;
},
async onChangeRegion(){
  const district = await this.setDistrict();
  let item =null, data=[];
  for(item in district){
    data.push(district[item])
  }
  this.options.province = data
  this.placeholder.province = (this.options.province.length > 0 ? 'เลือกแขวง/อำเภอ...':'เลือกภูมิภาค/จังหวัด...')
},
async getDistrict(id){
  try {
    const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/maps/drawmap/district/'+id)).body
    this.json.district[res['id']]={
      id: res['id'],
      province_id: res['data']['changwat_id'],
      name: res['data']['name_th'],
      maps: res['data']['map'],
      list: res['data']['list']
    };
    return res['id']
  } catch (error) {
    if (error.body) {
      if (error.body.alert) {
        return error.body.alert+' (District: '+id+')'
      } else {
        return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
    } else {
      return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
    }
  }
},
async getProvince(id){
  try {
    const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/maps/drawmap/province/'+id)).body
    this.json.province[res['id']]={
      id: res['id'],
      name: res['data']['name_th'],
      maps: res['data']['map'],
      list: res['data']['list']
    };
    return res['id']
  } catch (error) {
    if (error.body) {
      if (error.body.alert) {
        return error.body.alert+' (Province: '+id+')'
      } else {
        return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
    } else {
      return 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
    }
  }
},
loadProvince(){
  let value=null,count=0
  for(value of this.data.region){
    if(value.children){
      count=count+value.children.length;
    }else{
      count=count+1;
    }
  }
  return count;
},
async setPolygon(paths,color,weight,opacity){
  let polygon = new google.maps.Polygon({
    paths: paths,
    strokeColor: color,
    strokeOpacity: opacity,
    strokeWeight: weight,
    fillColor: color,
    fillOpacity: 0.35
  });
  polygon.setMap(this.map.body);
  return polygon;
},
async setProvinceChildren(id,data,count,error,details){
  let district=null, api =null,value=null;
  if(!this.json.province[id]){
    api = await this.getProvince(id)
  }else{
    api = id
  }
  if(api===id||api==id){
    details[id]=this.json.province[id].name
    count=count+this.json.province[id].list.length;
    for(district of this.json.province[id].list){
      data.push(district);
    }
    if(this.json.province[id].maps){
      this.map.data.province[id]=[]
      for(value of this.json.province[id].maps){
        if(value.length>0){
          this.map.data.province[id].push(await this.setPolygon(value,'#F4EBD9',2,0.5));
        }
      }
    }
  }else{
    error=api
  }
  await this.setPercentLoading()
  return {data:data,count:count,error:error,details:details};
},
async setProvince(){
  this.resetLoading(await this.loadProvince(),'โหลดจังหวัด...');
  let item=null,value=null, province=null, data=[], error=null, count=0, details={}, api={},map={district:{},subdistrict:{},province:{}},district=null;
  for(province of this.data.region){
    if(province.children){
      for(value of province.children){
        map.province[value.id]=true;
        api = await this.setProvinceChildren(value.id,data,count,error,details);
        data=api['data'];
        count=api['count'];
        error=api['error'];
        details=api['details'];
      }
    }else{
      map.province[province.id]=true;
      api = await this.setProvinceChildren(province.id,data,count,error,details);
      data=api['data'];
      count=api['count'];
      error=api['error'];
      details=api['details'];
    }
  }
  for(item in map.province){
    if(this.json.province[item]&&this.json.province[item].list){
      for(district of this.json.province[item].list){
        map.district[district]=true;
        if(this.json.district[district]&&this.json.district[district].list){
          for(value of this.json.district[district].list){
            map.subdistrict[value]=true;
          }
        }
      }
    }
  }
  await this.removePolygon(map.province,'province');
  await this.removePolygon(map.district,'district');
  await this.removePolygon(map.subdistrict,'subdistrict');
  this.load.active = false
  if(error!=null){
    this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'});
  }
  return {data:data,count:count,details:details};
},
async setDistrict(){
  let id=null,error=null,api=null,data={},province_id=null;
  const province = await this.setProvince();
  this.resetLoading(province.count,'โหลดเขต...');
  for(id of province.data){
    if(!this.json.district[id]){
      api = await this.getDistrict(id)
    }else{
      api = id
    }
    if(api===id||api==id){
      province_id=this.json.district[id].province_id;
      if(province.details[province_id]){
        if(!data[province_id]){
          data[province_id]={
            id: 'province'+province_id,
            label: province.details[province_id],
            children:[]
          };
        }
        data[province_id].children.push({
          id: this.json.district[id].id,
          label: this.json.district[id].name
        })
      }
    }else{
      error=api
    }
    await this.setPercentLoading()
  }
  this.load.active = false
  if(error!=null){
    this.$dialogs.alert(error,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'});
  }
  return data
},
async getAPI(){
  try {
    await this.resetLoading(1)
    let value2=null,value=null,minis={},wmops={},gps={},dts={},wms={},data={dts:[],minis:[],wms:[],table:[]},key=null,item=null,valueSet={dt:{},mini:{}},dt_code=null,mini_code=null,color={minis:{},dts:{},count:this.colors.length,wm:null};
    const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/maps/drawmap')).body
    if(res['dts']&&res['dts'].length>0){
      for(value of res['dts']){
        if(!dts[value.region]){
          dts[value.region]={
            id:value.region,
            label: value.region,
            children:[]
          };
        }
        dts[value.region].children.push({id:value.id,label:value.id+': '+value.label,lat:value.lat,lng:value.lng,color:value.color,children:[]});
        if(value.color&&value.color!=''){
          color.dts[value.id]=value.color;
        }
      }
    }
    if(res['minis']&&res['minis'].length>0){
      for(key in dts){
        for(item in dts[key].children){
          for(minis of res['minis']){
            if(dts[key].children[item].id===minis.dt_code||dts[key].children[item].id==minis.dt_code){
              if(minis.color&&minis.color!=''){
                color.minis[minis.id]=minis.color;
              }
              dts[key].children[item].children.push({id:minis.id,label:minis.id+': '+minis.label,lat:minis.lat,lng:minis.lng,color:minis.color})
            }
          }
        }
      }
    }
    for(key in dts){
      valueSet.dt={id:dts[key].id,label: dts[key].label,children:[]}
      valueSet.mini={id:dts[key].id,label: dts[key].label,children:[]}
      for(item in dts[key].children){
        valueSet.mini.children.push({id: 'dt'+dts[key].children[item].id,label:dts[key].children[item].label,children: dts[key].children[item].children})
        valueSet.dt.children.push({id:dts[key].children[item].id,label:dts[key].children[item].label,lat:dts[key].children[item].lat,lng:dts[key].children[item].lng,color:dts[key].children[item].color})
      }
      data.dts.push(valueSet.dt);
      data.minis.push(valueSet.mini);
    }
    if(res['gps']&&res['gps'].length>0){
      for(value of res['gps']){
        gps[value.unit_id]={
          course: value.course,
          gpsdate: value.gpsdate,
          lat: value.latitude,
          lng: value.longitude,
          n_gsm: value.n_gsm,
          nsat: value.nsat,
          server_date: value.server_date,
          speed: value.speed
        };
      }
    }
    if(res['wms']&&res['wms'].length>0){
      for(value of res['wms']){
        dt_code=parseInt(value.dt_code)
        mini_code=parseInt(value.mini_code)
        if(gps[value.gps_member_id]){
          if(!wms[value.region]){
            wms[value.region]={id: value.region,label: value.region,children: []};
          }
          if(!wms[value.region].children[dt_code]){
            wms[value.region].children[dt_code]={id: 'dt'+dt_code,label: value.dt_location,children: []}
          }
          if(!wms[value.region].children[dt_code].children[mini_code]){
            wms[value.region].children[dt_code].children[mini_code]={id: 'mini'+mini_code,label: value.mini_name,children: []}
          }
          wms[value.region].children[dt_code].children[mini_code].children.push({id: value.id,label: value.barcode+': '+value.label,gps_member_id: value.gps_member_id ,barcode: value.barcode,speed:gps[value.gps_member_id].speed,server_date:gps[value.gps_member_id].server_date,nsat:gps[value.gps_member_id].nsat,n_gsm:gps[value.gps_member_id].n_gsm,lng:gps[value.gps_member_id].lng,lat:gps[value.gps_member_id].lat,course:gps[value.gps_member_id].course,gpsdate:gps[value.gps_member_id].gpsdate})
        }
        if(value.gps_member_id){
          if(!wmops[value.region]){
            wmops[value.region]={id: value.region,label: value.region,children: []};
          }
          if(!wmops[value.region].children[dt_code]){
            wmops[value.region].children[dt_code]={id: dt_code,label: value.dt_location,children: []}
          }
          if(!wmops[value.region].children[dt_code].children[mini_code]){
            wmops[value.region].children[dt_code].children[mini_code]={id: mini_code,label: value.mini_name,children: []}
          }
          if(!color.dts[dt_code]){
            color.dts[dt_code]=this.colors[Math.floor(Math.random() * (color.count))]
          }
          if(!color.minis[mini_code]){
            color.minis[mini_code]=this.colors[Math.floor(Math.random() * (color.count))]
          }
          color.wm=this.colors[Math.floor(Math.random() * (color.count))]
          data.table.push({
            code: value.region,
            dt: color.dts[dt_code],
            dt_code: dt_code,
            dt_name: value.dt_location,
            mini: color.minis[mini_code],
            mini_code: mini_code,
            mini_name: value.mini_name,
            wm: color.wm,
            wm_code: value.id,
            barcode: value.barcode,
            full_name: value.label
          });
          wmops[value.region].children[dt_code].children[mini_code].children.push({id: value.id,fullname:value.label,label: value.barcode+': '+value.label,gps_member_id: value.gps_member_id ,barcode: value.barcode,color_mini:color.minis[mini_code],color_dt:color.dts[dt_code],color_wm:color.wm})
        }
      }
    }
    this.table.rows = data.table
    this.options.filter.wms=this.setValOPS(wmops,'wm',{});
    this.options.filter.dts=this.setValOPS(wmops,'dt',color.dts);
    this.options.filter.minis=this.setValOPS(wmops,'mini',color.minis);
    this.options.wms=data.wms;
    this.options.dts=data.dts;
    this.options.minis=data.minis;
    this.load.active = false
  } catch (error) {
    this.load.active = false
    if (error.body) {
      if (error.body.alert) {
        this.alert.message = error.body.alert
      } else {
        this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
    } else {
      this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
    }
    this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
  }
},
setValOPS(wmops,action,colors){
  let key=null,data=[],dts=[],minis=[],item=null,mini_code=null,wm=null
  for(key in wmops){
    dts=[]
    for(item in wmops[key].children){
      minis=[]
      for(mini_code in wmops[key].children[item].children){
        if(action==='wm'){
          minis.push({id:'mini'+wmops[key].children[item].children[mini_code].id,label:wmops[key].children[item].children[mini_code].label,children:wmops[key].children[item].children[mini_code].children})
        }else if(action==='mini'){
          minis.push({id:wmops[key].children[item].children[mini_code].id,color:colors[wmops[key].children[item].children[mini_code].id],label:wmops[key].children[item].children[mini_code].label,wms:wmops[key].children[item].children[mini_code].children})
        }else if(action==='dt'){
          for(wm in wmops[key].children[item].children[mini_code].children){
            minis.push(wmops[key].children[item].children[mini_code].children[wm])
          }
        }
      }
      if(action==='wm'){
        dts.push({id:'dt'+wmops[key].children[item].id,label:wmops[key].children[item].label,children:minis});
      }else if(action==='mini'){
        dts.push({id:'dt'+wmops[key].children[item].id,label:wmops[key].children[item].label,children:minis});
      }else if(action==='dt'){
        dts.push({id:wmops[key].children[item].id,label:wmops[key].children[item].label,color:colors[wmops[key].children[item].id],wms:minis});
      }
    }
    data.push({id:wmops[key].id,label:wmops[key].label,children:dts})
  }
  return data;
},
resetLoading(task,text='') {
  this.load.count = 0
  this.load.task = task
  this.load.percent = 0
  this.load.text = text
  this.load.active = true
},
async setPercentLoading() {
  this.load.count = this.load.count + 1
  this.load.percent = await Number.formatMoney((this.load.count / this.load.task) * 100, 2, ".", ",")
  if (this.load.percent >= 100) {
    this.load.text=''
    this.load.active = false
  }
}
}
}
</script>
<style lang="scss" scoped>
.card-option{
  border-color: #f0f3f5;
}
</style>